var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 887 1600",
    width: 1420,
    height: 2560,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h887v1600h-887z",
    fill: "#6F7381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h887v560l-7 2h-8l-1 4-9 2-4 1-5 5-4 1h-8l-6 2h-5l2 4-1 7-5 3-7-4-1 2h-2l-1 4-9-1-1-1v-6l-4 1-27 3-2-1-1-11-5-5h-6l-3 2-1 7 2 5 4 2v2l-13 3-2 4h-5l-2-2h-10l-13 2-17 3-2 1-15 1-9 2-18 1-3 1v2l-2 1h-12l-10-1-6-2-3-3v-4l6-1-1-2h-9l-3-3-19-1-11-2v-2l-4-1-4-2h-3l-1 2-10-1-1 2h-10l-10-3-3-3-1-8 7-3 15-4 5-2 5 1 8 6 14 5 15 3-1 4 12 1 4-2 1-2h-2v2l-2-1v-2l2-1 1-7h4l1 2 5-3h2v-2l4 1 1-5 2-1h6l6-9 7-4 4-1 6-1 3-2 1 3 5-1 11-5v-5h-13-3l-1 1h-11v-4h4l-3-3-1 2-7-1-1-4-8 1h-3l-1 2-7 2-10-6h-16l-7-1-4 1h-8v2l-6 3-2-3v-6h2v-6l6-9 4-1 4-2 8-1 1-3h2l-1-6-7-8v-4h-2l3-9h2v-6l-4 1v-2l-3 1h-20l1-2-3 1-2 2-6-1v-2l-2 1h-16l-1 3-5 5-9 4-2 1h-10l-2-2-2-7-2-4 1-7-5-2-1-3h3v-3l-3 1-2 4h-2v-5l-3-1-6-1v-2l-6-1-6-7-1-2-11-2h-4v2h-2l-1 5-8 1-4-1-3 1-2 4-2 3h-5l-1 2h-2l-1 5-1 4 1 5-2 2-5 1h-7l-1-1h-6l-4 5h-7l3 9-6 5h-3v3l-9 4-2 2 2 5 1 9 2 3 2 10 3 1 1 8h3v2l4 2 3 3-1 5-1 1-9 1-7 1-8-10-1-4h-2l-7-11-3-5-6-14-2-3-1-8-4-16-6-14-3-10-4-6-6-7-3-6-2-10-2-8 8 1h3l-3-4 1-5h2v-2l4-1 4 2-2 4v2l6-3 2-4 3-3h-10l-6-2v-5l4-5h2l1-4 4-5 8 1 3-4h3l2 15h3l1 2 8-11 4-7h3l2-5 4-1-2-9-6-12-3-3-3-7-2-6-7-8-10-8-10-4h-16l-5-6-3 4h-5l-2-2v-5l3-2h3l-8-12v-2h-2l-4-5-2-1v-2l-6-2-2-3 2-1h-15l-16 2-18 5-13 7-9 8-33 1-29 2-17 3-6 2 1 8 4 7v7l1 6-2 2-12-1 13 3 1 1v11l-3 12-1 1h-9l-10 6-7 7-8-1-6-4-5-4-5-5 4 7 12 8 1 2h-7l-10-5-5-3-1 5 6 3v2l4 1 5 3-1 4-7 3-8-4-10-6-1-5 4-10 3-4v-6l4-7 1-7h2l1-6 10-22 4-9h2l1-5 2-5 11-19 13-25 6-9 4-9-1 1-7 11-6 11-5 8-15 27-13 26-4 9-3 8h-2l-1 5-5 12-3 3-5-5h-4-3l-3-1-1-6v-10l2-3-1-9 1-13 3-12 3-4 1 1v10l2-4v-8h-3l2-4 4-4 1-4 2-6-2-1 3-7 1-7 4-9 5-10 3-14 2-6h2l1-5 6-9 4-2 7-14 5-9v-2l-2-1v3h-2v6h-4v2h-2l-2 5-1 2h-2l1-6 3-9-1-18-1-7-4-5 1 4v10l-3 2-2 12-11 22-2 5h-2l-4 10h2v-3h2l1-4h2l1-6h2v5l-2 6-2 5-2 6-5 9-3 8-5 11-8 16-2 5h-2l-1 3-3 3-10 29h-2l-1 17-2 6-1 14v13l-2 1-3-1v2l4 1 2 9 5 16 1 4 6 11v2l2 1v2h3v2l4 2 4 3h7l3 3-3 1v3l5-2 2-6h4l5 2 18-1v3l-8 2v1h10l3-2h9l7-2h4v-2l5 1-1 2h-2l-3 9-8 4-6 2-1 2 12-3-2 16-2 2-1 13h-3v-4h-2l-1 5-5 13 1 6-4 4-5-1-5-5-10-3-11-2h-37l-18 1h-30z",
    fill: "#B0B2C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(110,151)",
    d: "m0 0 3 1 3 5 2 19v6l-5 15h2l2-5 1-2h2v-2l3-1 1-5h2v-3l3 1-2 5-5 10-6 11-4 1-7 14h-2v5l-3 9-2 7-7 17-1 5-2 7-2 3 1 3-1 5-2 4-6 7h3l1 8-1 5-3 1v-12l-3 6-3 17v10l1 4-2 3v10l1 6 4 1 2-2 4 2 4 4 3-5 5-10 1-4h2l2-8 4-9 5-9 3-7 10-19 13-24 7-10 6-11 3-5 2 1-6 12-8 14-12 23-8 13-4 10h-2l-1 6-8 16-6 15h-2v7l-4 7v7l-4 5-3 8 1 5 9 5 8 4 7-3v-3l-8-4v-2l-4-2-3-3 2-4 12 7 9 1-13-9-3-5v-2l4 2 8 8 9 3 4-1 7-7 9-5h9l3-14v-9l-13-3-1-2 13 1 1-2-1-6v-6l-4-7-1-8 2-2 15-3 20-2 16-1 33-1 9-8 16-8 21-5 10-1h16l-2 3 7 4v2l4 2 2 4h2l8 12v2l-5 2v5l1 1h5l3-4 5 6h16l10 4 14 12 5 6 3 9 1 5 3 1 7 15v6l-4 2-2 4h-3l-2 5-8 12-4 2-3-3-1-15-4 2-2 3-8-1-4 5-1 3h-2l-2 4-2 6h5l1 1 10 1-1 3h-2l-2 5-6 2-1-4 2-2-7-1v2l-2 1 1 5 3 5-9-2-4-1 4 11 2 9 4 6 7 9 3 7 3 9 5 13 4 18 1 5 6 12 3 7 7 10v2h2l6 9 4 4 6-1 9-1 1-7-6-3v-2h-3l-2-8-2-1-2-5-1-5v-2l-2-1-1-13-2-1 4-4 5-2h3v-3l6-3 2-4-2-3v-4l7-1 4-5h6l1 1h7l6-2-1-8 2-2 1-4h2l1-3h5l4-6 4-2 6 1 5-1 1-4h2v-2l6-1 9 2 3 5 4 3v2l6 1v2h8l2 4-1 3 2-1 2-4h3v3h-3l4 4 2 1v7l3 6 2 6h11l7-4 3-1 6-7 5-1h13v2h6l3-3 6 2h18v2l4-1v6h-2l-3 9h2l2 5 7 9-1 4-2 2-1 2-8 1-6 3-2-1-2 5-3 4-1 6h-2l2 8 6-2v-2l11-1 2-1 6 1h16l10 6 7-2 6-2h6l1 3 7 1v-2l4 2v2h-4v4l11-1 3-2 1 1h13l1 1v5l-2 2-10 4-5 1-2-3-4 3h-7l-5 4-4 2-5 8h-7l-2 5-4-1v2l-7 4-2-3h-2l-1 7-2 3 1-1h2l-2 4-9 1-7-1 2-5-10-1-14-4-8-4-7-5-6 1-13 4-10 3 1 8 4 3 8 2 10 1 1-3 6 1 4 1 1-3 5 1 6 3v2h8l3 1 19 1 5 3h8v4h-6v4l3 1v2h5l1 1 10 1h14v-2l3-2 18-1 9-2 16-1 6-2 12-2 13-2h10l2 2h5l4-4 11-2-6-7-1-6 3-5 2-1h6l5 4 1 2v11l31-3h2l1 6 9 2 1-4h2l1-3 5 3 3 1 4-4-1-9 11-3h10l5-3 3-4 9-1 3-1 1-3 15-2v64l-7 1-3-3-9 1-1 4 5 2v2l-6 1v2h2l3 6v3l-8 3v-2h-4v-3l-4 1-6-2v5l-3 2 3 1v2l-5 1 4 2-3 3-1 4h-3v-2l-4-1-3 3v-2h-3v3h-5v-3h-2l-2 5-3-3h-3l2 8-1 7-4 3-6 1-7-4v-3h-3l-3-8-1-1-7-1v5l-7 1-1 5-5 1h-2l-1 2h-4l-1-5 3-1v-2h-7l-2-2-3 1-5-1 3-1v-8l2-4h-2l-2-5-10-3v2h-5l1 5h-2l2 3 1 6 2 1v2h5v3l-2 4h-2l-1 3h-2v3l3 1-1 9v5l-5-1-3 1-3-2v-2h-2l-2-2-1 2h2l-2 4-8 1 1 6 1 3h-2l-1 3-2 2h-8l-2 5-4 3h-5l-2-5 1-2 4-2v-2l-6-2-2-6-2-3v-3h-2l-2-3v-3h-2l-1 2v-2h-3l-1 3-6 1-5 1-4-1 2-4h-2v-5h-3l-1-2v-6l3-2v-4l4-2h3l1 6h3l1-3h3v3l4-1 1 2 3 1-1-6-2-2 7-3h7l11-3-1-3-4 2h-13l-3-3h3l-1-4-1-2 1-6 1 2 6 1 15 5 4 2v-2h-3v-2l-4-1-5-4-4-1v-2h2v-2l11-1 1-2 4-1 1-4 7-2 3 1v-2l-6-1-13-3-2-2h3l-3-3-10 1-7 1-5 2v3l4-2v2h3l3 3-1-4 18 3 4 2-3 5h-2v-3h-2v3l-6 1v-3h-4v3l-6-1-2-3h2l-3-3-3 2-8 1v-2l-7 2-5 2-4-1-5 1-1-5h-2l-3 3-3 1-1-3-5 1-2-1-1 2h-6l-3 2h-9l-5 4-4-1v-2l2-1v-2h-2l-3 6-11 1-6 1-8 4-4-1v2h2v5l-7-2 1 4-4 4h2v3l-5 2-1 3h-2v9l1 6 9 1h8l1-5 1-2 4-1 1-5 7-1 5 2 1 2-5 10-2 2v5h2v-4l3-1 2 1-1-5 4-8 3-3h6v3l6 3 2 5h-3v3h-2l-1-2-3-1v2l2 1-12-1 1 3 11 1h11v2l5-1 17 3 5 2 1 2 7 1 1 6-5 1 1 3 2 1 2 9 3 1 3 3v5l5-3 1 2 2-1 1 2h6l5 3 1 4-7 3-6 2h-4v4l1-3h4l9-1 2 2 1 4 4 10-8 3-1-1h-7l-5-3-5-5 1 3h-2v3h-3l-1 3-7-3v3h-2v2h-2l-1-4-2 2-5-3-1 7 5-2-2 5-3 4v4l-4 3-1 4-1 3-2 1-1 6-4 1v2l-3 1-3-1 1 3 3-1 2 2 6 1 6-4 3-1v5h-2l1 6 2 1h-2l-1 4v3l-1-2h-2l-2 9-3 2-1 5-2 3h-3v3l-2-1 3-9 2-4v-7l-4 6-3-1v3h-2v-2l-2 1-2 4-4 2h-11l-2 3 3 1-2 4h-3v5l-2 4 3 2 12-5 7 1-1 6-3 6-5 4v2l-15 4-10 1 1-3h3l1-5-6-8-5-2h-7l-8 1-1-3-6 1v2h-3v-7h-2l-1 2-2-1-1 3h-4l-2 6h-8v-3l-7 1-11 1-30 10 1 6-3 3-11 3-1 1h-5v-3h-2v4l-15 2-2-4 7-6h3l1 2h3l1-4-3-1v-3h3v-3l4-1v-2l12-2 10 1 10-3 4-2-7 1 1-3h2l2-5h2v-2l8-5 16-5 8-1v5l-6 3-3 2-13 6-2 1 12-2 7-1v-2l4-1 7 1 1-4 4-2h3v-3h-9v-3l-3-1 4-2v-3h-4v2h-3v-2l-3 2-1 2-6-1-4 4-6 3h-2v-3l-10 1h-10l1-4 1-2h2l2-4 2-1 2 1v2l2-2h-1l1-7 4-4 7-3-2-1 1-3h2v-2l-4 1-5 5-6 4-5 6h-2l-2 5-3 2-5-1-4 4-5 1 7 1-1 6-3 4h-2v2h3l1-3 4 1 1 3-3 2-1 4-10 2v-3l-5 3-5 5-3 1-2 4-5 5-8 7-7 8-3 3h-4v2h-2l-1 5-10 4-3-1-2 3-9 3-3-1-1 3-12 3v3l7-2h18l-2 4-4 6-12 6-9 1-3-3-1 2h-2v3l2 1h-4l-5 2h-4l-1 4-4-1 1 3 4-1h8l7-2h14l1 1 1-3 12-3 21-5h5l8-3 4-1h-11l-4-1-1 1-11 1-6-3v2l-4 1-1-2 7-9 4-3 9-2 16-2 11-3 5-1 11-1 21-3 7-2 17-2 36-9 17-7h4v3h4v-2l5-1-2 5h-2l2 5-2 3-10 1 1 5 4 1 2 4h3v-4l3 1 1 4-3 2 1 2-5 3-16 1v2h-4v3l-6 2v2l-5 1-1 2 4-1 24-2 3 9-1 1v5l3 2-3 2h-4v2h-2l-1 2-19 4-16 5h-7v2l-9 3-7 2-4 1h-2l1-4h-5l-1 5h-3v2l-6 3-6-1v-2l-5-2 1-3 11-5 14-3 10-2 16-3 4 1 1-4 8-2-3-3-5-2-8 1-1-2v-3l-7 5-7 1-2-1-1-4-36 9-9 3-16 5-9 3-15 4-18 5-32 5-1 2h-9l-18 7h-2v2l-5 2-1 1h-5v2l9-2 12-3-2 4-5 3-8 8-1 3-7 3-21 3-2-2v-2l5-5 1-3h-8l-2-1-1 5-3 1h-3-4v-2h2v-2l-10 1-5 2-11 1v3l2 1 3 1 8 1-2 4-11 1h-23l-19-2-8-1-10-2-13-1h-6v3l-3 1 13 2 17 1 11 5 39 1v2h3v-2l6-1 15-1 1 2-2 5-4 1-1 2-4 2h-7l3 5-1 5-3 3v5h-2l-2 4-3-1-1 3h-2l-2 7-2 3h-2v2h-2v2h2v5l-9 3-4 5-10 1-1 2-4 2-4 5-1 2-7 2-2 1-7-1v4l-5 1v-2h-9l-2 1-1-5-2-1-5 1-5-3h-7v-3l-4 4-5 1v-2l-4 2 4 1 3 2-1 3v6l-9-3-2-5-6-1-1 2h-2l-4 1-2 2h-5l-3 3-12-3h-5-2l-1 4h-7l-7-3v-3h-2l-1 7-1 1h-7l-1-6h-2l2 6h-3l-4 1v-6l-5 2h-5l-1 3-7-1v3l-5 1-13 4-20 4-16 4-8 1v-620l48-2h37l19 4 6 4 3 3 5-1 1-5-1-4 7-17h2l2 4 1-13 2-2 2-11v-4l-5 2h-6l1-3 13-5 4-9 2-2-4-1v2l-13 3h-7l-4 2h-9v-3l8-2-2-1-18 1-4-3-3 1-2 5-5 2v-3l2-2-4-1h-5l-8-6v-2h-3v-2l-3-1-1-4-6-11-4-16-2-5v-6l-4-1v-2h4v-15l1-12 2-6 2-17h2l3-11 7-20 4-4h2l3-10 7-12 4-10 3-8 7-13 2-8 3-10h-2l-1 6h-2l-1 4h-2v3h-2l2-7 6-10 10-20 2-12 3-2v-10z",
    fill: "#17181C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1141)",
    d: "m0 0 10 3 10 4 5 5 4 13v2h2l-1 3-7-1-7-2-1 11-4 10-3 5-7 11h-2v2l-5 5-9 10-8 10h-2v3l8-3v2h2v-2l3 1 1 4 3-1 2 1v-2l4-1 2 1 1-7h2v2h3l2 2 4-5 5 1v2h2l1-3 2 2h7l5-1-1-3-7 1v-2l2-1v-7l-8 1-5 1v-2l12-6 17-2h8l1 4-5 1h-9v10l-1 3 2-1h9l-3 5h-2v2l-5 2-1 5 2 2h2v7l-2 3-1 7-3 12-2 4h-2l-1 4-5 5-1 5 1 2-4 6-1 5-2 5 3 1-1 5h-2l-1 9-7 20-3 8-3 9h-2l-1 4-4 14-5 5-4 6-3 1-3 3-11 4h-2l-3 2-9 3-13 4-6 2-11 3-4 3-14 2-5 3-8 3-9 2-10 3-9 3-10 4-21 6-9 1v2l-21 8-11 4-13 4-10 2-4 3h-5l-2 2-18 6-13 5-18 5-10 3-12 5-20 7-9 3-16 5-7 3-14 5-2 1 8-1 9-3 5-2 30-9 13-4 14-4 5-2 16-4 12-5 4-1 13-4 8-2 10-4 14-4 9-3 25-8 17-5 13-4 14-5 26-8 12-5 13-4 17-6 9-3 14-4 8-3 7-3 14-2v2l3 1v2l-2 1-2 9v9l-4 16-2 9-3 12-2 2 6 3v-4h2l1-11 4-6 4-10 2-7 4-8 3-7h2l1-6 3-5h2v-2l4-3h4l1-6 7-2 4-1 8-3h2l1-4 9-3 16-6 19-6h8l5-3h7l9 2 4-1 1-6 6-2 2 1v-2l7-1 9-4 13-5 3-2 14-3 14-4 10-3h12l1-2 9 2 1 6 6-1v2l5-1 1-2h3v3h4v-2h3v2h3l1-3h2v2h5l1-2 4-1v4h6l1-4-3-2v-2l5-1 3 3v3h2l2 5 4 2 2 5 4-1v2h5v3l4 2-2 5 2 3-1 2h-2l2 4v3l-7 2-1-3-4 5-3 9-4 1v6l-4 2 1 2-5 2-2 3h-4v2l-3 1-2 2v-2l-8 3h-2v2l-12 2-1 3h-3l2 3 10-1 2-2h7l3-3 12-1 4 1v-3l4-1 2 1v2l3 1-1 6-3 3-4 2-1 3 14 2 4-2h6l2-2 1 3 5 2v5l2-1 1 6 4 1 3 1v-2h2l1 5-1 2-1 7 5 2 1-3 5 1 1 3 3-3h-2v-2l-3-1h2l1-6 1-2h-2l-1-3 5 2h7l1 2 4 1h3v2l-4 1 4 3 3 1 1 2 3 1v-2h-2v-2l7 1v2l4 1v2h2l1 5-1 2h2l2 8-1 8 2 1 1 27 2 2 3 17v11l2 7 3-2 1 7v-4-2h5l1-12-2-15v-8l1-9-2-7-2-4 1-4 1-6-1-7 2-2-1-4 4-4h2v-4l3-1v3l2 1 1-5 2-4 9 3 7 6 4 2 4-1v-3h5v-2l-2-1-1 2-2-1-1-12 1-4h7l3-1 1 7 5 1v-3h3l1-9 11 3 7 2v161h-887v-209h11l3 2v2h3l3 4 5 1v2l5 1v3l9 2h5l5-5h7l5-3 3 2v2l2 1h-2v5h5l6-6h7l6-4 4 1v-2h3l-1 4h-2v3l4 1v-6l2-1 1-3 7-3 2-5h2l2-3h3v-10h2v-2l4-1 3 1 2-5 4-1v-3l6-1 2-1 1 2h7l3-3 1-2 3 1-1 5-4-1 2 5 6-1 1-4-3-1 2-4 2-1 2-6 1-4h4v-2l2 1-1 3 1 1 1-4 4 2 1 5-8 1v2l7 2 2-3 4 1 2-1h6l6 1h2l1-2 5 1-1-7 4-2v2h3v2h2l1-2 5 1v4h3v-4l-1-6 7-3h5l5-3-2-5 2-3 3-1 5-7h3l1-4 2-1 1-3 4-2 3-4 7-1v-2l5-2 1-4 7-2 9 2 1 4 5-2 4 1 6-1v-9l6-1v-2l5 2 5-1-2-3-3-1-1 3h-1v-5l5-2h2l2-4 1-3 3-1 2-7 8 1 5 1 1-3 2-1 2-6 4-4 7-2 5-1 2-5h2l1-2 1-4 4-4 4 2v3l4-1 2-4 5-1v-2l6-3 5-7 5-4 5-5 11-12 2-3h2l2-5 6-7 5-10v-13l-1-8-1-4-2-1v-5h2l2-4z",
    fill: "#31353E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(543,1)",
    d: "m0 0h244l100 1v354l-7 1-2-6-4-1-2 4-7 2h-4v-2h-7l-3-3-5-1-11 1-5-3-2 2h-5l-4-3-7-1-2-2-12-2-2-2v-6l-16 3h-2l-2-4-5-4-1-4-4-1-6-2h-10l-12-3-15-1-2-2-2-1 2-4-6 2-1 4 1 4-6 2 1 6-6 3v-2l-5 3-1 3-9 2-1 2-5-1-2 1-5-1-9-1 1-3h2l1-5 1-2h-3l-1 5-5-2-6-10v-2l-7-1-1-4-3-1 1-4 4-3 1-6-11-1-1 5h-12l-1-1-1-11-1-5-8 2-1 1h-12-4l-3-2-6-2-1 1h-7l-3-2v-2h-7l2-4-2-4-8-1-4 6-5-1-3-4v-5l-1-1-11-1-1-3h-2l-1-5-5-1v4h-8l-3-5v-4l-5-2-3-1-1 1h-7l-5-3-12-2-4-1h-11l-6-5-4-3-5-1-1-5-5 1-3-1-7-8-5-2v-2h-10l-3-3-4 4-3-2-8-1v2l-7 1-18-2-9-3-4-4-5-1-3-1-2-4-7-1-4-4-5-3-8-4-7-4-1-5-13-3-8-5-9-2-3 1v-2h-4l-6-6h-6l-5 2-6 2-11-1-3-5-5 2v2h-10l-9 1-14-3-3-1-2-6 3-12 4-2 6 3 4-1 1-4 5-3 2-4h2l1-3 9-3 2-2 13-3 2-2 2 1 2-4 7-1 3-1 2-5 3-4h2v-2l6-4h2v-2l7-2 3-1 2-4 4-2 1-4-3-1 2-4 7-1h2l5-10 8-2 7 1v2h6v-3h2l2-10 7-8h7l4-9v-7h7l2-6 7 1 4-3h12l2-6 6-1 5-1 10-7h23l8 2 1 3h13l4 4 3 4 3-2h6l-1-4-3-6h4l-1-3h4v-4l2-1 1-3h3v-2h-19v-1z",
    fill: "#D9DCE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,492)",
    d: "m0 0h29l24 1v2l-2 1-3 7-4 6 10 5h3v2l3 1 4 8-1 6 7 1v12l6 1 2 1v3h2v2h6l2-5h3v2l3 1v2l5 1 2 2h6l3-2 7 2 9-1 4-1 6-1h9l5-1h16l1 2h7l2 1 1-2v2h2v-2l4 1 1-2-4-2 3-3 3 1 9-1v-2h2v2l13-1 1 1 5-2 3-3 2-9 5-2 2-2 2 32 3 17v4l4 2 4 4 2 7-3 1 2 9 3 3 2 3h3v3h-2l-2 7-1 4 1 4 1 2 5 1 5 6 2 1v2l6 2 1 3 14 5v2l5 2v2h3l-3 9h2l2 4-6 5h-4l-1-2-5-1-3-2v7h2v3h-2l-5-5-6-4v-3h-6l-2-4-5-2 3 7h-4l-3-3-1-3-1 2h-2v6h2l-1 3-5-1-2-4-4 1v5l-3 1-1 5-3 11-2 2-2 7-3 7-1 4-2 9-4-1v3l1 1v13l-4 1-6-1-12 5-1 5h-2l1 6 1 5 9-1-2 4-4 2-4 4h-3l-1 2-7-1-1 1h-7v-2l-10 4-3-1-1 3-2-1-10 5-2-1 2 7 5 2v3l-6 2-7-4v2l-6 1v-2h-6l-1-1-1 5-4-2v-2l-4 2-3 3 1-1 4-2v5l-2 2-1 6-3-1v-2l-1 2-8 2 1-7 5-5-3-3-4 1-4 3-7 3-16 12-5 1-1 6h-3v2h-7l-4 3-1-2-3-1v6l-6 2 1 4 5 2v4h2l2 4-1 5-1 2-7 1v3h-10l-1-3h-2v4l-6 5-3-1 1 2 5 2 1 2v3h-3v5l-3-1 1 5h2l-2 6-2 1v-2h-2v3h-2l-1 3-6 1-2 3 3 1 10-1 26-4 12-3 2-2 9-1 17-5 1-3 4-1 2 3v-2l15-5 2 1v-2h5l1-3 9-5 4-3h3v-2l8-3 3-2h5v4h6l1 5-6 4-2 2h-4v2l-9 2-5 3-11 1-2 4-1 6h-2l-1 3-4 2-1 2-4 2 3 4-1 6-4-1-1 5 1 2-1 4h11l5 1 8-1 1-2 5 1 3 1v-2h3l2-3 4 1 4-2v3l6-3h3l7-1v2h7l1 3h2v-2l4-1-1-3 3-1 1-2h3l1-3h6l5-3 8-1 6-5 4-2h3l1-3 4-2v-2l5-2 3-2 3 1 2-4 3-4h2v-2l6 1 4-1v-2l9-4 3-2h4l1-3 3-3-4-1-1-3 5-1 3 2 6-1 8-4 3-4h5v6l-4 1-1 5h-8v3h-2l3 9 3-1 1 3-1 6-7 1v-5l-3-4-1-7-2 3-9 2-1 6h-3l-1-2-7 5-2 3h-2l-1 2-5 1v2l-7 1-1 5 2 1 1 4-2 7-2 4-1 4 8 2 3-1 2-5h2l2 4 1-4-3-3 4-3 1 2 3 1 3 5 2 1 1-2 10 4-3-7 5-2 3 2 1 4h2l2-2 1 5h3l1-5h2v5h4l1-5 3-1 10 2 4 1 6-2 4-1 3-1 3 2 2 4 2 1-1-5v-10h2l3 3v2h2l1 4 6-1 2-3-6-1-2 1 2-4 3 1 3-3 10-2 1 3 5-3h3v2h2v2l3 1v2l6-2 4-1 2 1v2h3l1-4 5-2 1-5 5-1 5 2h4l3-5 3-2h3l1-4-1-4v-2l12-4 4-4 5-2h7l1-4h2l-1-5 3-3v2l2-2h3v-3l2-2 3-5 6-1 1-3 3-3 5-1v-3l-7 2-2-2 1-2-11 1-16 3-2 1h-11l-6-1h-10l-10 2-11 3h-12l-3-3h4l-1-4 2-3-11 6-6 4-4 2-3-1 1-2h3v-2h-2v-3l7-3 5-4 1-4-5-1-9 5-6 2v2l-5 1-1-3-14 7-16 7-9 5-3-1 2-5 1-3h3l-3-5-1-3 1-2-2 1h-9v-7l5-4 2-5-2-6-4-2-6 3h-3l-2 4-7-1-7 8h-9l2-6 2-3h2l2-4h2v-2l4-1 2-4 4-4 2-3 9-1v-2l4-1 2-4 10-3h4l-2 5-3 1-2 4h-2l1 7v5h-2l2 4 10-3v-6l9-4 4-1v-2l9-3 4-2 1-4 4 1 1-3 10-2 5 1 2 3 5-1v2l9-1 4 4v2l16-2 8-3 1-1 7-1 5-1v3l4 2-15 5v2l7 1h6l-1 3-8 4-7 3-1 1h7l11-3 5 1 4 6 1 4 6-1 4 2-2 2 9-2 1-3 3 1v3l7-1 7 1 10 4 2 4 6 1v2h3l1-2v-2l1-4 2-1 5-2 2 1v-2h2l1-5h2l1 2 3-6h5l2-4 2 1 1-5h2v-2l2-1v2h3l-1-6v-3l4-3 2 2-1 2h3l1-2 4 1 1-4 4-1 1-4 6-5h2l2-7 2-3 4 1v-2l7-4-1-3 1-3 4 2v3l-1 3-2 2 1 4-9 1v3h-2l1 3h-4l-1 3-2 1-3 6-3 1v3l-4 4v3h-3l4 7v2l5 1-1 3h-2v3l5 1-1 5 9 2 8-3h3l-1 3-5 3 1 3 3 1v2l4-2v-3l13-1 5-2 3-5 7-1-2-5 2-5-1-3 4-2v-4l2-1-2-1v-3l3-2-5-1h-3l1-3h2v-2l5-3 4-4 6-3 2-3-8 1 1-7-3-5-1 7-3-4-3-6-1-9-6-21-2-10-1-4v-4l10 1h9l3-3-3-3v-2h-2v-4l3-1 2 1-1-5 4-8 3-3h6v3l6 3 2 5h-3v3h-2l-1-2-3-1v2l2 1-12-1 1 3 11 1h11v2l5-1 17 3 5 2 1 2 7 1 1 6-5 1 1 3 2 1 2 9 3 1 3 3v5l5-3 1 2 2-1 1 2h6l5 3 1 4-7 3-6 2h-4v4l1-3h4l9-1 2 2 1 4 4 10-8 3-1-1h-7l-5-3-5-5 1 3h-2v3h-3l-1 3-7-3v3h-2v2h-2l-1-4-2 2-5-3-1 7 5-2-2 5-3 4v4l-4 3-1 4-1 3-2 1-1 6-4 1v2l-3 1-3-1 1 3 3-1 2 2 6 1 6-4 3-1v5h-2l1 6 2 1h-2l-1 4v3l-1-2h-2l-2 9-3 2-1 5-2 3h-3v3l-2-1 3-9 2-4v-7l-4 6-3-1v3h-2v-2l-2 1-2 4-4 2h-11l-2 3 3 1-2 4h-3v5l-2 4 3 2 12-5 7 1-1 6-3 6-5 4v2l-15 4-10 1 1-3h3l1-5-6-8-5-2h-7l-8 1-1-3-6 1v2h-3v-7h-2l-1 2-2-1-1 3h-4l-2 6h-8v-3l-7 1-11 1-30 10 1 6-3 3-11 3-1 1h-5v-3h-2v4l-15 2-2-4 7-6h3l1 2h3l1-4-3-1v-3h3v-3l4-1v-2l12-2 10 1 10-3 4-2-7 1 1-3h2l2-5h2v-2l8-5 16-5 8-1v5l-6 3-3 2-13 6-2 1 12-2 7-1v-2l4-1 7 1 1-4 4-2h3v-3h-9v-3l-3-1 4-2v-3h-4v2h-3v-2l-3 2-1 2-6-1-4 4-6 3h-2v-3l-10 1h-10l1-4 1-2h2l2-4 2-1 2 1v2l2-2h-1l1-7 4-4 7-3-2-1 1-3h2v-2l-4 1-5 5-6 4-5 6h-2l-2 5-3 2-5-1-4 4-5 1 7 1-1 6-3 4h-2v2h3l1-3 4 1 1 3-3 2-1 4-10 2v-3l-5 3-5 5-3 1-2 4-5 5-8 7-7 8-3 3h-4v2h-2l-1 5-10 4-3-1-2 3-9 3-3-1-1 3-12 3v3l7-2h18l-2 4-4 6-12 6-9 1-3-3-1 2h-2v3l2 1h-4l-5 2h-4l-1 4-4-1 1 3 4-1h8l7-2h14l1 1 1-3 12-3 21-5h5l8-3 4-1h-11l-4-1-1 1-11 1-6-3v2l-4 1-1-2 7-9 4-3 9-2 16-2 11-3 5-1 11-1 21-3 7-2 17-2 36-9 17-7h4v3h4v-2l5-1-2 5h-2l2 5-2 3-10 1 1 5 4 1 2 4h3v-4l3 1 1 4-3 2 1 2-5 3-16 1v2h-4v3l-6 2v2l-5 1-1 2 4-1 24-2 3 9-1 1v5l3 2-3 2h-4v2h-2l-1 2-19 4-16 5h-7v2l-9 3-7 2-4 1h-2l1-4h-5l-1 5h-3v2l-6 3-6-1v-2l-5-2 1-3 11-5 14-3 10-2 16-3 4 1 1-4 8-2-3-3-5-2-8 1-1-2v-3l-7 5-7 1-2-1-1-4-36 9-9 3-16 5-9 3-15 4-18 5-32 5-1 2h-9l-18 7h-2v2l-5 2-1 1h-5v2l9-2 12-3-2 4-5 3-8 8-1 3-7 3-21 3-2-2v-2l5-5 1-3h-8l-2-1-1 5-3 1h-3-4v-2h2v-2l-10 1-5 2-11 1v3l2 1 3 1 8 1-2 4-11 1h-23l-19-2-8-1-10-2-13-1h-6v3l-3 1 13 2 17 1 11 5 39 1v2h3v-2l6-1 15-1 1 2-2 5-4 1-1 2-4 2h-7l3 5-1 5-3 3v5h-2l-2 4-3-1-1 3h-2l-2 7-2 3h-2v2h-2v2h2v5l-9 3-4 5-10 1-1 2-4 2-4 5-1 2-7 2-2 1-7-1v4l-5 1v-2h-9l-2 1-1-5-2-1-5 1-5-3h-7v-3l-4 4-5 1v-2l-4 2 4 1 3 2-1 3v6l-9-3-2-5-6-1-1 2h-2l-4 1-2 2h-5l-3 3-12-3h-5-2l-1 4h-7l-7-3v-3h-2l-1 7-1 1h-7l-1-6h-2l2 6h-3l-4 1v-6l-5 2h-5l-1 3-7-1v3l-5 1-13 4-20 4-16 4-8 1zm599 263 2 1-1 3h-2z",
    fill: "#31353E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(389,1414)",
    d: "m0 0h9l4 3v2l7 2 1 3 2 2-2 2 1 2-2 10h-3l1 5-2 13-2 6-2 12-4 8-4 13-6 5-27 9-12 3-10 4-18 5-5 1-1-1-4 4-7 3-9 3-4 3h8l17-6 22-6 5-2 6-2 10-3h2v-2l9-3 13-3h6l-1 8-4 10-2 3v6l-3 8v7l-4 6-1 4 1 9h-2v3l-3 2-1 3h2v5h4l1-3h-2l1-5 1-2h2v-6l2-1 2-5 3-8h2l1-7 4-10 10-30 5-5 11-4 7-3 24-7 10-4 14-3h6l1 4-4 11-2 4-1 10 2 1v2l-3 1-2 3v2l3 1h-2l3 4 3-12 3-3 4-13h2v-6l2-2h3l-1-4 3-8 8-3 4 1 1-3 2 2 3-4 5-1 4-2 7 1v-2l6 1 7 2 1 3h2v2l11 2 3 3h-3v3l5-1v5h2v4h-2v3l4 1 2-4 5 2-2-6 4 1v6l7-2 5-2-5-2 2-5h9l1-2 5 1 3-1v-3h2l2 5 2-1-1-4 4 1 3 1-1-6 3-1 1-2 5 4 1 5-1 4 4 1-2-5 2-4 1-6-8 2v-5l-3-5-4-1-3-5v-2h2v-2l5 1-2-7h2l-1-8 4-1v-2l5 1 3 2v2l4 2 3 8 4 12v2h2l2-11-2-1v-2l1-5-4-1-5-5-1-5 3-3v-3h5v2l4 2 1 1v7h3l2 9v19l-3 14 1 2-3 5-5 2-1 4-2 4v4h-3l-2 5h4l4 1 1 4h5v-2h2l1 4h-3l-2-1v4l9-2 1-4-1-4h6v-4l-3-1 3-3h2v2h2v2h-2v6l4 2 2 2 1 2h2l1-3h2v-5l3-3 6 1 2-3 3 1v-2h2l1-5 4-1 3 2v2l3 1-1-3h2v5l2-5v-3h-2l-2-6 5-3 2 1 1 3 4-1-2-2 3-1-3-2 6-2 5-1h3l2 4 2 1-1-5h10l5 1-1 3 4 1 3-3 1 1 2-3h3v2h-2l-1 4 3-1 1-3h2v-2h2l1-6-2-4-2-1v-3l5-2 3 2v2l7 2 4 2-1 3-8 1 1 7 4 1 1-3 2 2h7l-3 3-1 3h3l3-5 2 4-4 4 6 5 1 5h-3l1-2-4 3 1-5-4-2 1 4-1 5 6 4h8v3l3 1 2 7h3v16l2 2-2 2v2h2l1 11 2 9 1 16 2 4v10l1 7 1 1h21l-1-3-1-15-3-11v-23l3 1 1-3h-5l1-7-1-1-1-7v-11l-1-2v-10l3-1-1-7 3-8 7 1v-2h2v4l5-2 3 1v6l-3 2 1 2 4 1v4l2 1 1 12 2 5v10l-1 10h2v11h2l2 3 4 1 1-14 1-1v-11-4l1-5h-2l-1-16-1-2 3-4-1-3h2l-1-3h2l2-9 3-3h2v-2l2-1 1-3h9l2-3-3-1h3l1-2 2 2 1-2h2v127h-887v-123h8l7-7 6-2 2-1 2 5h2l3-6-3-1 2-3h2l2 5 5 5 2 1 4 8 5-1-2-1 1-3-1-1 2-3 11-1 4 2 1-7 10-1 3 3h-3l1 9-2 2 1 3h-2v-2h-2l-1 4h-6l-1 2 7 1 4-3 1 2h-2v3h3v-4l5-2-1-2 5-1v-3l2-1-1-6h-3l1-3 5 1 1 4-1 2 9 2v-2h2l2-5h2l1-4 2 1v9l3-3 2-3 4 1 4-3 1-1-2-2h6v2l6-1v9l3 3-1 2-5-1-2 6h-3-2l-1 2-2 2-8 1-5 2-3 2-2-1-2 4-11 2h-7l-4 2h-3v3h-2v2l-9 2-2 3-10 3h-2l-1-2-1 4-19 6-11 4-7 3-5 2 11-1 20-7 13-4 10-2 12-3 4 1v-2h6v-2l17-5 6-2 13-5 13-4h3l-1 5h3v-5l4-1 1-2 11-3h6l6-3 7 1 1-3 2-1 7-2 4-2 5 1 5-1 2 2 5 1v-2l5-2v-2l4-2 1-2 9 1 1 1v7h2l-1-5 4-3 1 1 1-3 6-2v-2h5v-3l5 2v-2l7-2 1 3 3-3 1-3h10l1-2 1-1h5l1-3h2v-2l5 1v-2l5-2h4v-2l9-3h5l7-3 7 1 2-4 1-1 10-2h8l-1-3 10-4 2-1h6l1-2 9-1 1-2 7 1h3l1 2 2-2 3-2 2-4z",
    fill: "#17181C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h887v2h-344l-526 1 8 1 3-1h37v5h15v6h2v2h3l2-5 3-1v-2h7l6 3 5 5 8-2 7 2 3 2 9 3h7l11 2 2 2 1 9 6 6 2 5 3 5 2 8 11-1 2-6 5-1 3 2-2 5-3 8h-2l-2 4-2 2v9l-4 1v3l13-3 1-3 4 4-1 5-5 3h-2v2h-2v2l-5 3-6 10-4 4-8 1-2 7-8 8-4-4-1-10-6-1-3 5-3 7-4-2-1-7-1-3-9 2-4 2-5 1-7 3v5l13 6 8 4v2l4 2 7 9v3h2v4h2l1-2v2h7v3l2-3h2l2-6 8-18h1v7l-3 8-1 6h-2l-1 8h-2v3l8 1h4l4-4 3 2 2-2 2 3 5-2 4 2v5l11-1 3 3 7 3 6 4v2l4 1 1 2 5 2 4-1 10 2h2 15l6 5 6 1 1-5 9 5 2 4 1 3 3 1v-2l5-1 10 2 4 9v2h5l-2-3 4-2 1 2 4-1 1 5h2v-2l4 1 4 5 12-1 7 2 5 4 7 2 7-1 3 1-1 8 3 2 1 4 3 2 6 2 2 2h4l2 6 2 1 1-2 1 4h7v2h3l1 3 4 2 9-1 6-3-4-6 1-8 4-4 2 5v4l5 1v7h-3l1 3 3 1 1 5-4 4v2l7 1 2 2-2 8h2v7l-2 3-4 1-4 3h-7l-8-3h-8l-3 1v-2h-6v2l-15 11-5 5h-12l-11-4-7-3h-5l-1 3-4-1-1 6 3 1 1 4h-3l-2 3h-5l-2-2v-5l3-2h3l-8-12v-2h-2l-4-5-2-1v-2l-6-2-2-3 2-1h-15l-16 2-18 5-13 7-9 8-33 1-29 2-17 3-6 2 1 8 4 7v7l1 6-2 2-12-1 13 3 1 1v11l-3 12-1 1h-9l-10 6-7 7-8-1-6-4-5-4-5-5 4 7 12 8 1 2h-7l-10-5-5-3-1 5 6 3v2l4 1 5 3-1 4-7 3-8-4-10-6-1-5 4-10 3-4v-6l4-7 1-7h2l1-6 10-22 4-9h2l1-5 2-5 11-19 13-25 6-9 4-9-1 1-7 11-6 11-5 8-15 27-13 26-4 9-3 8h-2l-1 5-5 12-3 3-5-5h-4-3l-3-1-1-6v-10l2-3-1-9 1-13 3-12 3-4 1 1v10l2-4v-8h-3l2-4 4-4 1-4 2-6-2-1 3-7 1-7 4-9 5-10 3-14 2-6h2l1-5 6-9 4-2 7-14 5-9v-2l-2-1v3h-2v6h-4v2h-2l-2 5-1 2h-2l1-6 3-9-1-18-1-7-4-5 1 4v10l-3 2-2 12-11 22-2 5h-2l-4 10h2v-3h2l1-4h2l1-6h2v5l-2 6-2 5-2 6-5 9-3 8-5 11-8 16-2 5h-2l-1 3-3 3-10 29h-2l-1 17-2 6-1 14v13l-2 1-3-1v2l4 1 2 9 5 16 1 4 6 11v2l2 1v2h3v2l4 2 4 3h7l3 3-3 1v3l5-2 2-6h4l5 2 18-1v3l-8 2v1h10l3-2h9l7-2h4v-2l5 1-1 2h-2l-3 9-8 4-6 2-1 2 12-3-2 16-2 2-1 13h-3v-4h-2l-1 5-5 13 1 6-4 4-5-1-5-5-10-3-11-2h-37l-18 1h-30z",
    fill: "#707482"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(574,311)",
    d: "m0 0h16l10 2 4 4 8 3 6 3 4 5v2l3 1-1 7 4 2 1 2 4 1v2h3l1 10-3 6 1 11h7l4-1 10 2 1 5 2 1 3 8 1 1 10 2 7 3 1 2h3v-7h-2v-6l3-1 6 6 1 8 6 1 3-2 3-1 1-2 8-1 3 4 7 2v2h2v2l4-1v-4h2l-1-4-2-2 2-3h4l3 5 4 2v2l3 1-2 2 1 3h3l2 3 6 1 9-3 3 5h-2v10h4v5h6l2 2 2-1v2l6-2 1-2v2h3v2l4 1v10l-2 4 1 5v10h-3v3h-2v3l3 1-1 6-2 2-1 5h3l1 5h3l1 5h5l2 3 4 2-5 5h-2l-2 4h-2v-2l-5 1-6 6-5-1-4 2v3l10 1 12-2 5-1 19-1 21-2 7-3h2l1-3h7l3-2 1-5 5-4h2l1-4 2 1v-2l6-5h2l1-5 5-5h2v94l-7 2h-8l-1 4-9 2-4 1-5 5-4 1h-8l-6 2h-5l2 4-1 7-5 3-7-4-1 2h-2l-1 4-9-1-1-1v-6l-4 1-27 3-2-1-1-11-5-5h-6l-3 2-1 7 2 5 4 2v2l-13 3-2 4h-5l-2-2h-10l-13 2-17 3-2 1-15 1-9 2-18 1-3 1v2l-2 1h-12l-10-1-6-2-3-3v-4l6-1-1-2h-9l-3-3-19-1-11-2v-2l-4-1-4-2h-3l-1 2-10-1-1 2h-10l-10-3-3-3-1-8 7-3 15-4 5-2 5 1 8 6 14 5 15 3-1 4 12 1 4-2 1-2h-2v2l-2-1v-2l2-1 1-7h4l1 2 5-3h2v-2l4 1 1-5 2-1h6l6-9 7-4 4-1 6-1 3-2 1 3 5-1 11-5v-5h-13-3l-1 1h-11v-4h4l-3-3-1 2-7-1-1-4-8 1h-3l-1 2-7 2-10-6h-16l-7-1-4 1h-8v2l-6 3-2-3v-6h2v-6l6-9 4-1 4-2 8-1 1-3h2l-1-6-7-8v-4h-2l3-9h2v-6l-4 1v-2l-3 1h-20l1-2-3 1-2 2-6-1v-2l-2 1h-16l-1 3-5 5-9 4-2 1h-10l-2-2-2-7-2-4 1-7-5-2-1-3h3v-3l-3 1-2 4h-2v-5l-3-1-6-1v-2l-6-1-6-7-1-2-11-2h-4v2h-2l-1 5-8 1-4-1-3 1-2 4-2 3h-5l-1 2h-2l-1 5-1 4 1 5-2 2-5 1h-7l-1-1h-6l-4 5h-7l3 9-6 5h-3v3l-9 4-2 2 2 5 1 9 2 3 2 10 3 1 1 8h3v2l4 2 3 3-1 5-1 1-9 1-7 1-8-10-1-4h-2l-7-11-3-5-6-14-2-3-1-8-4-16-6-14-3-10-4-6-6-7-3-6-2-10-1-4 3 3 3 7 2 1 1 5h6l-1-6 9-3v2l9-3v-4l7-1 1 1 10 1v-3l5-2 5 1 8 3v-2l3-3-4 1-1 2-3-1-2-5 5-4 5 2v3h2v-2l9-1 5-3v-5l4-9h4v-2l3-2 6-2 7-2h6v-3l4-4 3-6 9-9 10-3 4-1 4-4-2-5 3 1v2l14-3 1-3h7l2 2 2-1-1-2 6 1 1 1 6-1 2 5 4 1 4-3v-4l13 1-2-7-5-1-8-2v-4l17-2 2-3h1v-3l5-5v-5l-3-1 2-4 10-2z",
    fill: "#707482"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,492)",
    d: "m0 0h29l24 1v2l-2 1-3 7-4 6 10 5h3v2l3 1 4 8-1 6 7 1v12l6 1 2 1v3h2v2h6l2-5h3v2l3 1v2l5 1 2 2h6l3-2 7 2 9-1 4-1 6-1h9l5-1h16l1 2h7l2 1 1-2v2h2v-2l4 1 1-2-4-2 3-3 3 1 9-1v-2h2v2l13-1 1 1 5-2 3-3 2-9 5-2 2-2 2 32 3 17v4l4 2 4 4 2 7-3 1 2 9 3 3 2 3h3v3h-2l-2 7-1 4 1 4 1 2 5 1 5 6 2 1v2l6 2 1 3 14 5v2l5 2v2h3l-3 9h2l2 4-6 5h-4l-1-2-5-1-3-2v7h2v3h-2l-5-5-6-4v-3h-6l-2-4-5-2 3 7h-4l-3-3-1-3-1 2h-2v6h2l-1 3-5-1-2-4-4 1v5l-3 1-1 5-3 11-2 2-2 7-3 7-1 4-2 9-4-1v3l1 1v13l-4 1-6-1-12 5-1 5h-2l1 6 1 5 9-1-2 4-4 2-4 4h-3l-1 2-7-1-1 1h-7v-2l-10 4-3-1-1 3-2-1-10 5-2-1 2 7 5 2v3l-6 2-7-4v2l-6 1v-2h-6l-1-1-1 5-4-2v-2l-4 2-3 3 1-1 4-2v5l-2 2-1 6-3-1v-2l-1 2-8 2 1-7 5-5-3-3-4 1-4 3-7 3-16 12-5 1-1 6h-3v2h-7l-4 3-1-2-3-1v6l-6 2 1 4 5 2v4h2l2 4-1 5-1 2-7 1v3h-10l-1-3h-2v4l-6 5-3-1 1 2 5 2 1 2v3h-3v5l-3-1 1 5h2l-2 6-2 1v-2h-2v3h-2l-1 3-6 1-2 3 3 1 10-1 26-4 12-3 2-2 9-1 17-5 1-3 4-1 2 3v-2l15-5 2 1v-2h5l1-3 9-5 4-3h3v-2l8-3 3-2h5v4h6l1 5-6 4-2 2h-4v2l-9 2-5 3-11 1-2 4-1 6h-2l-1 3-4 2-1 2-4 2 3 4-1 6-4-1-1 5 1 2-1 4 9 1 9 5 5 2 3 3 5-3 3-1 1 3v1l7-1 5-2 8-3 12-2 8-4h2l1-3 13-1-3 3-13 5-7 5-6-1-3 1-1 3-10 2-10 5 2 2v-2h2l2 6 8 3 3 3 3 1 1-2 1 3h-2v2l7-1v-3h5l1-5h3v2h3v3l3-2 4-1 6-2h6l-1 4-7 4-2 5h-6l-4 2-3 3h-13l-9-1-6-2-5-1v2h-7l-4-3h-3l-3 3-8 1-5 1-14-1-10-3-3 1h-27l-2-1v-7l-2-6-10-1-10 2-10 3-5 1-1-3-8 2h-5z",
    fill: "#32363F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,1331)",
    d: "m0 0 10 2 1 6 6-1v2l5-1 1-2h3v3h4v-2h3v2h3l1-3h2v2h5l1-2 4-1v4h6l1-4-3-2v-2l5-1 3 3v3h2l2 5 4 2 2 5 4-1v2h5v3l4 2-2 5 2 3-1 2h-2l2 4v3l-7 2-1-3-4 5-3 9-4 1v6l-4 2 1 2-5 2-2 3h-4v2l-3 1-2 2v-2l-8 3h-2v2l-12 2-1 3h-3l2 3 10-1 2-2h7l3-3 12-1 4 1v-3l4-1 2 1v2l3 1-1 6-3 3-4 2-1 3 14 2 4-2h6l2-2 1 3 5 2v5l2-1 1 6 4 1 3 1v-2h2l1 5-1 2-1 7 5 2 1-3 5 1 1 3 3-3h-2v-2l-3-1h2l1-6 1-2h-2l-1-3 5 2h7l1 2 4 1h3v2l-4 1 4 3 3 1 1 2 3 1v-2h-2v-2l7 1v2l4 1v2h2l1 5-1 2h2l2 8-1 8 2 1 1 27 2 2 3 17v11l2 7 3-2 1 7v-4-2h5l1-12-2-15v-8l1-9-2-7-2-4 1-4 1-6-1-7 2-2-1-4 4-4h2v-4l3-1v3l2 1 1-5 2-4 9 3 7 6 4 2 4-1v-3h5v-2l-2-1-1 2-2-1-1-12 1-4h7l3-1 1 7 5 1v-3h3l1-9 11 3 7 2v34h-2l-1 3-2-2-2 5-5 1-5-1-1 4h-2v2l-5 5-2 7-1 3h-2l2 4-3 3 1 2v16h2l1 3-2 5 1 1v11l-1 1-1 11-1 3-5-1-1-3h-2v-11h-2v-20l-2-5v-12l-3-1 1-4-5-1-1-3 4-1v-6l-3 1h-2-3v-4h-2v2h-7l-2 9v5l-2 1v10l1 4v9l1 7v4l-1 4h5l-1 4-2-1v22l3 11 1 18-2 1h-19l-2-2-1-12-1-7-1-2-2-23-1-5v-8h-2l-1-4 1-1-1-5v-9l1-3-3 1-2-4-1-4-2-1v-3l-8 1-6-4-1-5 1-5 5 1v3h2l1 2-2-6-6-3 5-5-1-3-3 5-3-1 1-4v-1l-5-1-1-1-1 2-5-1v-7l8-1v-3l-4-2-7-1v-3l-4-1-3 1v3l4 2 1 4-2 5h-2v2h-2l-1 4-4 1 2-5h2v-2l-3 1-2 3-2-1-2 3-4-1v-3l-10-1-4-1 1 5-4-2-2-3-2 2-9 1 3 2-2 2 4 1-5 2-4-1 1-2-3-1-5 2 3 4-1 2h2l1 4-2 5-3-2h2v-4l-1 3h-5l2-1v-2l-4-1-3 2-1 3h-2v2h-3l-2 3-6-2-1 3h-2v5h-2l-1 4-4-2-5-5v-6h2v-2h-2v-2l-2 2v6l-4 1-2-1 2 5-2 5-2-1-7 1v-4l4 1v-4h-2v2h-5l-1-4-5 1-3-2 2-5h3l-1-6 3-3 1-3 6-4v-4l3-15v-19l-1-9h-3l-1-7-4-3v-2l-4 1-2 5-1 5 4 2 3 3 3 1-2 5 2 1v2 7l-2 4h-2l-6-16-2-6-3-2v-2l-4-2-4-1v2l-3 1v8h-2l3 5-1 3-5-2v2h-2l3 5v2l5 1 3 6v3l1-1h6l-1 9v4 2l-4-1v-7l-5-5-3 3v5l-4-1-3-1 1 4 3 1h-5l-2-5h-2v3l-4 2-4-2-1 3-9-1-2 5 7 1-3 3-10 2-2 1v-7h-2l1 5-5-2-2 5-4-2v-3h2v-4h-2l-2-4h-3l1-4-4-1-6-2-2-1v-2h-2l-3-3-5-1-6-2v2h-7l-5 3-5 1-3 3h-4l-10 2-1 7-1 5-4 2-1 6h-2l-1 8-3 6-2 2-3 12-2 2-4-10 3-4 3 1v-2l-3-1 2-13 4-9 1-7-16 3-13 4-7 3-18 5-7 3-12 5-3 3-5 14-3 10-5 12-3 11h-2l-1 7-2 2-2 5h-2l1 4-1 2h-2v4l-2 1v2h2l-1 4-4-1-1-3 1-2h-2l1-4 3-1v-3h2l-2-10 5-10 1-9 2-6v-6l3-4 5-16-19 4-5 2h-4v2l-33 11-15 4-14 5h-10l3-3 4-3 12-3 5-3 3-3v2l5-2 18-5 10-4 12-3 18-6 10-4 4-3 4-13 4-8 3-17 2-7 1-12h3l1-11v-3l-1-5-9-2v-3l-4-2-1 2v-2l-11 2-2 4-3 3h-4l-5-1v-2h-4l-1 3-9 1-9 3-5 2-4 2v2l-18 3-3 4h-7l-9 3-5 1-7 1v2l-5 2h-4v2l-5-1v2l-3 3h-5v6l-2-3-10 1-2 5h-2l-2-2-1 1h-5v2l-5-2 2 5-2 1-1-2-4-1 1 3-7 1-1 4h-3l-1 2 1 4h-4v-7l-9-2v4h-5v2l-5 2v2h-5l-4-2-6 1-3-1-5 3-4 1-3 1-1 2h-7l-5 1-1 2-10 1-7 1 2-3 21-6 10-4 4-1 13-4 8-2 10-4 14-4 9-3 25-8 17-5 13-4 14-5 26-8 12-5 13-4 17-6 9-3 14-4 8-3 7-3 14-2v2l3 1v2l-2 1-2 9v9l-4 16-2 9-3 12-2 2 6 3v-4h2l1-11 4-6 4-10 2-7 4-8 3-7h2l1-6 3-5h2v-2l4-3h4l1-6 7-2 4-1 8-3h2l1-4 9-3 16-6 19-6h8l5-3h7l9 2 4-1 1-6 6-2 2 1v-2l7-1 9-4 13-5 3-2 14-3 14-4 10-3h12z",
    fill: "#31353E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(878,878)",
    d: "m0 0 4 2 2 4 3 1v408l-1 2-3-1-3-5v-2l-3-1-5-4 1 6v7l-2 1-3-4v-2h-2v-2l-3-1-3-5-1-6-3-5-4-2-1-3-3 3-9-2-6 2 1 4-4 1-5-2-7 2-6 1-9 3-2 6-4 2-1 2-5 2-1 1v14l-2 5h-2l-1 3h-3l-1-2v-7l-3-9-2-4v-3l-6-1-14 1-2 1h-9l-1 3-9 1-1-2 2-3 11-2 8-3 5-3 1-2 5-2 3-1v-2h2l-1-3 3-13v-7l-1-3v-18l-2-6v-13l-4-15-1-13-2-20v-16l-2-21-4-16v-3l1-2-4-16-1-12 1-2-2-5v-16l-3-13-2-4-2-7-2-4-5-1v-2l-21 3-24 5-10 2 1-3 7-1 8-3 12-3 8-3 8-2 10-5 1-5 2-1 2-7 5-5-1-8-3-3v-8l3-3 2-5 7 2h7l8-4 9-3 10-2 4-2 11-1 13-3 4-1v-5l3-5 2-7h9l2-4 9-2h6l-1-7-3-1-3-6 3-7 2-1 1-8 4-2-3-6 7-2 4 1 2-2h3v-3l7-2z",
    fill: "#D9DCE5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,492)",
    d: "m0 0h29l24 1v2l-2 1-3 7-4 6 10 5h3v2l3 1 4 8-1 6 7 1v12l6 1 2 1v3h2v2h6l2-5h3v2l3 1v2l5 1 2 2h6l3-2 7 2 9-1 4-1 6-1h9l5-1h16l1 2h7l2 1 1-2v2h2v-2l4 1 1-2-4-2 3-3 3 1 9-1v-2h2v2l13-1 1 1 5-2 3-3 2-9 5-2 2-2 2 32 3 17 3 7 4 7-2 3 1 13 1 5-3 3h-4v4h-2l-1 3-1-3 1-2-3 1-3-3-7-1h-7l-12 4-4-1v3h-3v3h-4l-2 4h-2v3h-3v3h-5l-1 4v-2h-2l1 4h-3v-2l-3-1v2h2v2l-2 1 8 1 4 2h3l3 1-1-4 3-1 2-4 2-3 9-5h4l3 3v2h-2v7l1 2-2 4-5 1-9 1-3 3-1 3h-3v2l6-2-1-4 4-1 2 4 2 5 5 1-1 3-4 2-1 2-5 4-4-1-1 2-4-1v-3l3-1v-2l-1 2-2-1v-3l-2 2-4-2-1 3-8 2-4 2v4l2 2-2 1-16 1-7-3v-2h-2v2h-2v2l-4 1-8-4h-9l-2 2-11 1-1-3h2v-2l-7-2-2-1v2l-4-2-13 1-7 2-13 3-12 1-2 1h-11l-6 4-5 3-4 5h-3l-1 3h-12z",
    fill: "#6F7381"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(63,966)",
    d: "m0 0 4 1 2-1-1 4-3 3h-2l-1 10h-2v-2l-6 1-3 3-6 2v4l17 3 9 1 1-2 4 1v2l7 1 5 1 7 1 16-2 6-3 3-2 13-1 4 1 18-1 12-3 4-3 7 1v2l7-2 2-4 4-2h7v1h-6v3l-3 1 13 2 17 1 11 5 39 1v2h3v-2l6-1 15-1 1 2-2 5-4 1-1 2-4 2h-7l3 5-1 5-3 3v5h-2l-2 4-3-1-1 3h-2l-2 7-2 3h-2v2h-2v2h2v5l-9 3-4 5-10 1-1 2-4 2-4 5-1 2-7 2-2 1-7-1v4l-5 1v-2h-9l-2 1-1-5-2-1-5 1-5-3h-7v-3l-4 4-5 1v-2l-4 2 4 1 3 2-1 3v6l-9-3-2-5-6-1-1 2h-2l-4 1-2 2h-5l-3 3-12-3h-5-2l-1 4h-7l-7-3v-3h-2l-1 7-1 1h-7l-1-6h-2l2 6h-3l-4 1v-6l-5 2h-5l-1 3-7-1v3l-5 1-13 4-20 4-16 4-8 1v-105l7 2 7-1-1-4-3-5-2-2 4-1 1 4 9 1 2 1 1-2 3 1v-2l19-10 4-5 5 1 5-2 1-1z",
    fill: "#31353E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,1141)",
    d: "m0 0 20 1 7 5h9l3 5 4 1h7l4-3h9l2 1 1-5h3v-2l6 1 1 3-1 2h2l1 3-3 12-8 14-20 25-14 8-19 6-19 7-14 3-11 2-14 7h-2v2l11-3 9-3 18-4 12-4 15-6 18-6 8-4 9-7 11-11 1-2h2l2-5h2l2-5 5-12 2-3 1 1v10l-8 13v3l4 4 2 7v8l-4 6-6 8 5-2 1 4-6 8-6 5-17 9-21 8-16 1-17-1-9 4-4-1-4-3h-8l-3-1 1-3 8-3h13l13-1-1-1-22-1-11 4-7 3-5 1h-13l-6-2 1-3 12-6 5-2-1-2-18 6-12 6-10 3-20 2-7 2h-4v2l-12 5-5 3h-2l-2 4-6 8-4 9-1 7v9l5 2v-2l5 1 4 4 7 2-1 3-3 1 9 3 6 1-1-5 1-4 3-5-7 1-2-7v-5h3 2v2l2-2v-6l2-1-1-7 4 1 3-4h2v-4l11-4h6l-5 4-7 6-1 6 7-1 4 2 4 1-1 7h2l1 3-2 4-5 1-3-6-4-6-5 1-2-4-3 3v4l-1 10 3-1v2l10-2 1 2h4l1 7-5 6 1 4-1 1 4 3 8 1 1-9 6-4v-7l3-1v-2l3-1h9l8-2 3-2 5 1 1-4 3-2v-6l5-3 6 1 4-2 2 2 9-1 6 2 4 4 3 9 8 2v2h-2l-2 7h2l1 3-1 3-6 1-2-1v2h-2l-2 4-3 2-7 2-5 2-9 1v2l-12 3h-3l-1 4-17 3h-5v2l-5 2-8-1v2l-4 1v-4-5h-2l2-4 1 1 1-2-4-2-18-1-6-2-5-2v2l-3 3v12l5 5v3l4 1 5 3v2l-12 5-24 8-12 2v1h-12l-6-10-1-8 2-8 6-17h2v-8l4-12 1-1h6l-1-4v-9l4-16 4-15 6-14 4-11 3-5 2-3 10-5 13-4 5-2h3l1-4-16 2-7 1v-2l4-2 1-2-6-3 1-2h14l6 1h24l-2 2-3 1h10l3-2-4-2v-4l3-3h3v5l7-1 1-3-2-1 5 1 5 5-5 3h-8v2h-2v2h5v-3h3v2h4l3 3 4-3 9-1h13l13-1 2-1-6-2v-1l19 1h19l9-2 9-7v-1l-25-3-17-5-2-1 1 3-18 7-9 4-2-1 5-5 15-6h4l1-2h2v-2l-5-2-6-4-12-11-3-4v-7l6-12 3-3 10-3 5-1 2-1z",
    fill: "#181A1E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(470,437)",
    d: "m0 0 9 1 5 2 2 4 4 3v2l6 1v2h8l2 4-1 3 2-1 2-4h3v3h-3l4 4 2 1v7l3 6 2 6h11l7-4 3-1 6-7 5-1h13v2h6l3-3 6 2h18v2l4-1v6h-2l-3 9h2l2 5 7 9-1 4-2 2-1 2-8 1-6 3-2-1-2 5-3 4-1 6h-2l2 8 6-2v-2l11-1 2-1 6 1h16l10 6 7-2 6-2h6l1 3 7 1v-2l4 2v2h-4v4l11-1 3-2 1 1h13l1 1v5l-2 2-10 4-5 1-2-3-4 3h-7l-5 4-4 2-5 8h-7l-2 5-4-1v2l-7 4-2-3h-2l-1 7-2 3 1-1h2l-2 4-9 1-7-1 2-5-10-1-14-4 3-3 2-12 4-7-1-6-4-4-5 3-4 3-10 3-7 1-8-7-5-2-5 2-3-3-3-7-4-4v-2h-3l1-5 5-5 4 2 7 3 5 1h12l3-2 2-7h3v-2l-3-1v-3l4 1 3 1v-3l3-3 1-7-2-2-15-3-4-5-1-5-13 1-1 8-3 5-4 2-2 4-6 2-4 1-7 8-5 5h-3l-1 6-4 6-15-3-4-1-7 6-1 3-6 2-8-1-12-1v7h-2l-1-6-4 1-1 6h-2l2 4 1 4 6 2 1 3h10l12 1 5 2 13 1 10-1h10l3 1v2l3 1-2 10 1 2-2 10-2 30-2-1-2-10-3-10-4 1-2 13-3-1 2 18 3 10-1 3-2-3v-3h-2l1 5v7l-4 2-3-4-1-10-1-12-2-12h-6v9l-2 4-1 10-4-5-3-3 2-9-1-5-2-4h2l-2-4-7-3 2-2 13-4 7-4h2v-3l-9-1h-10l-5 1-13-1-4-7 1-5-3-1-1-4-3-4-3-1v3l-4-1-5-7-2-4-9-3-15-2h-10v-3l4 1 13-2 1-7-6-3v-2h-3l-2-8-2-1-2-5-1-5v-2l-2-1-1-13-2-1 4-4 5-2h3v-3l6-3 2-4-2-3v-4l7-1 4-5h6l1 1h7l6-2-1-8 2-2 1-4h2l1-3h5l4-6 4-2 6 1 5-1 1-4h2v-2z",
    fill: "#31353E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(886,560)",
    d: "m0 0h1v64l-7 1-3-3-9 1-1 4 5 2v2l-6 1v2h2l3 6v3l-8 3v-2h-4v-3l-4 1-6-2v5l-3 2 3 1v2l-5 1 4 2-3 3-1 4h-3v-2l-4-1-3 3v-2h-3v3h-5v-3h-2l-2 5-3-3h-3l2 8-1 7-4 3-6 1-7-4v-3h-3l-3-8-1-1-7-1v5l-7 1-1 5-5 1h-2l-1 2h-4l-1-5 3-1v-2h-7l-2-2-3 1-5-1 3-1v-8l2-4h-2l-2-5-10-3v2h-5l1 5h-2l2 3 1 6 2 1v2h5v3l-2 4h-2l-1 3h-2v3l3 1-1 9v5l-5-1-3 1-3-2v-2h-2l-2-2-1 2h2l-2 4-8 1 1 6 1 3h-2l-1 3-2 2h-8l-2 5-4 3h-5l-2-5 1-2 4-2v-2l-6-2-2-6-2-3v-3h-2l-2-3v-3h-2l-1 2v-2h-3l-1 3-6 1-5 1-4-1 2-4h-2v-5h-3l-1-2v-6l3-2v-4l4-2h3l1 6h3l1-3h3v3l4-1 1 2 3 1-1-6-2-2 7-3h7l11-3-1-3-4 2h-13l-3-3h3l-1-4-1-2 1-6 1 2 6 1 15 5 4 2v-2h-3v-2l-4-1-5-4-4-1v-2h2v-2l11-1 1-2 4-1 1-4 7-2 3 1v-2l-6-1-13-3-2-2h3l-3-3-10 1-7 1-5 2v3l4-2v2h3l3 3-1-4 18 3 4 2-3 5h-2v-3h-2v3l-6 1v-3h-4v3l-6-1-2-3h2l-3-3-3 2-8 1v-2l-7 2-5 2-4-1-5 1-1-5h-2l-3 3-3 1-1-3-5 1-2-1-1 2h-6l-3 2h-9l-5 4-4-1v-2l2-1v-2h-2l-3 6-11 1-6 1-8 4-4-1v2h2v5l-7-2 1 4-4 4h2v3l-5 2-1 3h-2v9l1 6 9 1h8l1-5 1-2 4-1 1-5 7-1 5 2 1 2-5 10-2 2v5l2 1-4 1-1-2-4-1 1-2-4 1-4-1-6 1h-7l-3-2-3-1 1-4-3-1 1-5h-2l1-11 4-6h3l1-4 3-1-1-4 2-4 4-1v-3l3-2-1-5 4-4 7-1 10 1 7-1v-5l3 1v2h2l1 2h4v-3l6-4 3 4 2-2 5-1 3-6 9 2v-3h-9l-13-2h-16l-12-1-4-6v-4h-2l1 6-5-2-1-7-2-2-4-1v-5l-4-1v4l-9-2-3-1-1 4-5 1-13-3-12-4 1-12 7-1-2 2 1 8 4 3 8 2 10 1 1-3 6 1 4 1 1-3 5 1 6 3v2h8l3 1 19 1 5 3h8v4h-6v4l3 1v2h5l1 1 10 1h14v-2l3-2 18-1 9-2 16-1 6-2 12-2 13-2h10l2 2h5l4-4 11-2-6-7-1-6 3-5 2-1h6l5 4 1 2v11l31-3h2l1 6 9 2 1-4h2l1-3 5 3 3 1 4-4-1-9 11-3h10l5-3 3-4 9-1 3-1 1-3z",
    fill: "#32363F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,1228)",
    d: "m0 0 2 1-3 1-1 3-7 3-10 5-13 8h-2l-1 4-3-3-1 5-5 2 3 4-2 4-3 1 1-5-4 2-4 9v9l4 2 2-4 4-4 14-5 6-5h2l2-4 4-2h4v-2l4 1-2 13-3 4-1 5-5 6-6 9v10l2 4-1 1-3 14-2 3h-3l2 1-1 10-4 5v3l-2 1-1 4-5 1-1 2h-3v6h2l-1 5-2 1-1 4h-2l1 6-4 3-7-1-4-2 2 4-1 4-7 1v-2h-3v-2l-2-1 1-3-2 1v5l-5 3h-2l3 3v2l-4 1v4h-3l-1 2-8 1-1 1h-5v-2h-3v2l-5 4-2-1-1-7h-2l1 8h-4l-2 5-7 2-9 1-4 1-2 2v-2h-3l-1 2h-4l-1 3-6 1-4 1-5 1h-3l-1 4-13 1-9 3h-2l-1 2h-3l-7 1-3 1-7 1v-5l7 1v-5h-6v-2h-2l-1-4-4-3 1-4 4-2 2-2 3 2-2-8 3-1v-3l8-1h2l2-6h2l-1-4-3 1v-6l-4-2-3-1-1-5 4-1 8 5h6l-2-6 2-2 7-1 1-6h2l1-8 2 1 1-2 5 2 2-6h2l2-3v-6l3-1h3l4-7 3 3 1 5h4l1-2 1 2 3-1v2l6-2 1-9 10-1 1-4 8 1 2-2-2-5v-6h2l1-5 6-1 1-2h-3v-5l3-1v-3l-5 1h-4-4v-3h-3l-1-6v-2l-2-2 3-3 2-5h2l2-4 1 2h8v-3l-5-1 1-5 4-1v-2h2l1-4 2-5 10 1 1-3 4 2-1 6h-3l-1 5-4 5-2 5h-2l-1 5 1 3 3-3h2l1-4h2v3l4 1v-2l4 2 5 1 1-5 3 1 1 2 6 2 3 4v5l-4 2-3 5 1 5 3 3h5l-1-5h2l1-9-4-9 3-11 5-7h2l1-4 5-5 4-2v-2l11-7 4-3h4v-2l11-6 10-4z",
    fill: "#17181C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(53,746)",
    d: "m0 0 5 5 3 7-1 2h2l2-4 2 3 3 1-2 4 4 1 1 2-2 1 6 3 1 4h2l2-2 5 4h-2l1 2 7-3 9-1 2 1-2 5-6 4h-2v2l-14 10-11 8-5 1-1 6h-3v2h-7l-4 3-1-2-3-1v6l-6 2 1 4 5 2v4h2l2 4-1 5-1 2-7 1v3h-10l-1-3h-2v4l-6 5-3-1 1 2 5 2 1 2v3h-3v5l-3-1 1 5h2l-2 6-2 1v-2h-2v3h-2l-1 3-6 1-2 3 3 1 10-1 26-4 12-3 2-2 9-1 17-5 1-3 4-1 2 3v-2l15-5 2 1v-2h5l1-3 9-5 4-3h3v-2l8-3 3-2h5v4h6l1 5-6 4-2 2h-4v2l-9 2-5 3-11 1-2 4-1 6h-2l-1 3-4 2-1 2-4 2 3 4-1 6-4-1-1 5 1 2-1 4 9 1 9 5 5 2 3 3 5-3 3-1 1 3v1l7-1 5-2 8-3 12-2 8-4h2l1-3 13-1-3 3-13 5-7 5-6-1-3 1-1 3-10 2-10 5 2 2v-2h2l2 6 8 3 3 3 3 1 1-2 1 3h-2v2l7-1v-3h5l1-5h3v2h3v3l3-2 4-1 6-2h6l-1 4-7 4-2 5h-6l-4 2-3 3h-13l-9-1-6-2-5-1v2h-7l-4-3h-3l-3 3-8 1-5 1-14-1-10-3-3 1h-27l-2-1v-7l-2-6-10-1-10 2-10 3-5 1-1-3-8 2h-5v-181l6-2 6 2h2l2-2 2 2 2-1 3 1 5-2 2 2 2-1v2h2l1-3 3 1v-2l10-2 2 1z",
    fill: "#32363F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(784,1011)",
    d: "m0 0h3l4 4 2 1 1 7-2 1-3-1v2l3 1-1 2 3 1v2h2l1 2 4-1 3-3h2v-6h2l3 3 5 2 7 1 7 3-3 4v3l5 2 2 8v3l5 2-5 6 1 1 9 2 3 2-1 5 2 1v2l4 4-5 4-8 2-1 3-5-1v4l-16 2-3 2h-5v2l-3 2 4 4-5 2 2 9-1 6h4l-1-11 1-5 2-4 3-1 3-3 5 1 3 3 1-5 3-2h7l1 2 9 2 2 4-3 5-1 3-4 3-1 2-5-1-2-1h-4l2 7 1 3-1 3h6l2 4-1 9-1 4h-2v2h2v4l2-1h8l1 4-4 6 3 7v3l4-1 2 5 1 8 4 4-1 3-7 1-5-2 1-4-3-2v-8h-3l-1 2v-2l-5 3-2-1-1 5-1 2 9-1-3 5v4h5l-1 4-1 5 2 4 2 1v6l6 1 4 4 1 7-3 1-2-1 1 6-1 5-1 6-2 7h-2v4h-2v-2l-4-1-4 2-3 5-7 4h-3l-6-3-5 5-7 1-8-1-8-7-3-7-1-1-3-26-2-10v-9l-1-7 3-6h-2v-6l-1-1 1-11h-2l-2-7-1-8v-6l-2-4-1-13v-7l-1-11 6-7-6-2-1-10-1-5 2-5-1-7v-10l-3-3-1-9-2-7 1-5-1-2 2-5 2-9 3-1-1-3 6-1v-3z",
    fill: "#707482"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(295,319)",
    d: "m0 0 19 4-5 5-4 5-4 10-1 5-1 20-2 5-3 1-8-6 4 6v4l-4 1-20 1-4 1v2l6-2h16l10-3h5l2 7h-2l-1 3-6 1-9 3-7 5h-2l-3 9-6 7-10 14-5 12-3 10-2 12-4 15-3 8-3 6h-3l-2 2v-3l-5 3-10 3-12 4-2 4h-2v2h-2l-3-3-4 1-10-2-9 3-2 6-8 5-14 2h-10-2l-7 1-1-4 5-13 3-12 2-3h-4l1-7 2-2 3-8 2-2h4l-1-4-3-6 4-2 2-9 7-7 6-20 7-6 14-11 4-2v-2l13-9h2l-1 6-11 16-8 10-2 3 7-7 8-6 11-15 12-18 4-5 4-4 1-5 9-10 14-11 6-4 11-8 3-1-1 5-6 8-5 6 2 1v2l-4 4-7 8-1 3 7-8 5-2-1 5-4 9-1 2 6-8 7-15 8-10 7-11 5-5z",
    fill: "#6F7381"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,965)",
    d: "m0 0 2 1-9 3-7 3-7 4-14 2v3l4-1v3l-1 4v13l1 8-11 1h-14l-4-1 2 3 5 1 24 1 6 9 5 10 8 10v2h2l-1 4-3 1-1 7-3 4-9 3-2 2-7 2-12 2-4 2-24 4-5 2-25 5-12 1-7 4-18 4-10 2-7-1-6-7 1-5-4 1-5-6 1-1h42l8-2h5v-2l-11-1h-9l-13-2h-22l-6-3v-10l-4-4-4-1-1-5-3-5 2-16 3-1v-2l3-1 4-5 1-4h3l1-4 6-5h2v-2h5l4-2h3l2 2 1-2 7-1 2 3 10-1 6-2v-2l19-4v-2l-3-1 6-2v-3l11-4 3 1v6l-4 2 1 1 16-1 36-5-9-2-11 2h-6l1-2h2l1-3 9-3 8-6z",
    fill: "#31353E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(808 1e3)",
    d: "m0 0h32v2l7 2 1 1 1-2h2v3h7l1 6-1 3 3 1v3l4 1v5l-3-1v-2l-2-1-1 3-3 1v3l5 2-1 7v3l4 1-2 5h-2v2l9-1 2 2 2 9 2 1-1 4-6 5v5l-3 4-7 1-1 2 12-1 2 2 5 1 5 3 2 9 2 2-1 3-14-2-1 4 1 1v5h-5l-7 8v2l-5 3 3 9 5 2 3 5-4 1-1 4 4 4 1 6h-4l-2 8 4 2-1 4 3-3 9 1h3l3 1v2h2v3h2v-2l3 1 1 5v49l-6 1-1-3-3-1v4l2 1-2 1-1 6-6-1-5 1v3l-6 1-1 3-6 3-5 5-7 2-1 2-17 5-16 6-6 1-9-2-3-2v-2l-4-2-1-4v-5l-3-7-4-36-1-5 1-4-2-10v-10l-1-14-3-16-3-29v-14l-3-15-1-19 1-5h-2l-1-2-3-32-1-7 2-8 5-3 15-4 11-2 16-2zm-24 7-10 4v3l-6 1 1 3-3 1-2 9-2 6 1 2-1 5 2 6 1 9 3 3v13l1 6-2 5 2 8v5l6 2-6 7 1 18 1 13 2 5v10l2 4 1 6h2l-1 11 1 4v3h2l-3 7 1 9 1 11 3 20 1 11 3 4 2 5 7 6 12 1 4-2 4-4 6 3h3l7-4 4-6 4-1 3 1v2h2l1-4h1l3-10v-7l1-4-1-3 4 1 1-2-1-6-4-4-6-1v-6l-3-2-1-5 2-4-1-3h-4l1-5 2-4-9 1 2-4v-3l3 1 4-3 1 2v-2h3v8l3 2-1 4 6 2 7-2-2-4-2-2-1-10-3-3-3 1-1-5-2-6 4-5-1-4h-8l-2 1v-4h-2v-2h2l2-9-1-6-1-2h-6l1-5-2-3-1-5h5l2 2 5-1v-2l4-2 3-7v-4l-7-2-3-1-1-2h-7l-4 3v4l-3-3-6-1-2 3-4 2-1 7-1 2 1 10h-4l1-8-2-7 5-2-4-4 3-2v-2l7-1 1-1 16-2v-4l5 1 1-3 4-1 7-3 2-3-5-4 1-2h-2l1-5-5-3-7-1v-3l4-4-5-2-1-8-1-3-5-2 1-4 2-3-7-3-9-2-5-2-1-2h-2v6l-4 1-2 3h-3l-1-2h-2v-2l-3-2 1-2h-3v-2l4 1 1-4-1-4-5-3-1-2z",
    fill: "#AFB1BF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(39,929)",
    d: "m0 0 10 1 3 9-1 5h29l4-1 9 3 16 1h34l9 1h31 3 6l2 1 6 10 1 3 7 6 1 3-3 5-1 2-17 4-3 5-7 1v-2h-7l-5 3-11 3-18 1-8-1-9 1-4 3-5 2-19 2-8-1-8-3-1-2-3-1-1 3-9-1-17-3-4-2 3-1 4-4 5-1 1-3h6v2h2l-1-6 2-6 3 1 2-4-5-1v3l-3-1-5 2-4-1-4 5-17 9h-2v2l-6 1-9-2-1-3h-3l3 3 1 3 2 2-1 3-3 2-6-1-5-2v-57l13-2 2 2 9-2 5-2z",
    fill: "#323640"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,1211)",
    d: "m0 0h14l6 1v1h-9l1 3 4 1h6l6 3-1 3-6 4-7 2-1 1h-5l-1 4-7 1-3 1v2h-2v5l-5 5-4 2-2 5v8l-2 2v3h-2l1 3 4-2 4-4 16-8 15-4h17v1l-20 2-7 2h-4v2l-12 5-5 3h-2l-2 4-6 8-4 9-1 7v9l5 2v-2l5 1 4 4 7 2-1 3-3 1 9 3 6 1-1-5 1-4 3-5-7 1-2-7v-5h3 2v2l2-2v-6l2-1-1-7 4 1 3-4h2v-4l11-4h6l-5 4-7 6-1 6 7-1 4 2 4 1-1 7h2l1 3-2 4-5 1-3-6-4-6-5 1-2-4-3 3v4l-1 10 3-1v2l10-2 1 2h4l1 7-5 6 1 4-1 1 4 3 8 1 1-9 6-4v-7l3-1v-2l3-1h9l8-2 3-2 5 1 1-4 3-2v-6l5-3 6 1 4-2 2 2 9-1 6 2 4 4 3 9 8 2v2h-2l-2 7h2l1 3-1 3-6 1-2-1v2h-2l-2 4-3 2-7 2-5 2-9 1v2l-12 3h-3l-1 4-17 3h-5v2l-5 2-8-1v2l-4 1v-4-5h-2l2-4 1 1 1-2-4-2-18-1-6-2-5-2v2l-3 3v12l5 5v3l4 1 5 3v2l-12 5-24 8-12 2v1h-12l-6-10-1-8 2-8 6-17h2v-8l4-12 1-1h6l-1-4v-9l4-16 4-15 6-14 4-11 3-5 2-3 10-5 13-4 5-2h3l1-4-16 2-7 1v-2l4-2 1-2-6-3z",
    fill: "#31353E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(831,768)",
    d: "m0 0 1 4h3l1 2 4 1v4l9 3 1 3 5-2 2 3 4 2-1 2 3 6v-2-2l5 2-1 6 3-1 4 2 5 2 8 3v3l-2 1-2 4-3 1-3 5-1 10-6 4-8 2v2l-5 2v3l-5-1-3-1-1 3-13 4-7 3h-6l-1 3h-4l-3 8-9-1-2-1-1 3-7 3-1-1h-20l-1 1h-9l-1-4 1-5-14-2-8 3-2 2h-6v-13l-2-3v-7l-2-4h-2v-3l6-2h2l-3-3 7-1v2l13-1 1-4 7 1h3l2-4h3l-1-4 3-1 1 5 4 1 2 1v-4l14-4 3-7h3l1-5 4-5 1-2 6-1v-6l1-3-2-5 3-2-2-6 1-1 8 1 5 5 2 1v3l2-1 2-7z",
    fill: "#B0B2C0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(236,487)",
    d: "m0 0 1 2-3 21-3 15-1 11-2 2-1-9-4 2h-1l-2 10h-2l-3 4-5 1v-2l-3 1h-10v-2h-2v2h-4l-1 2h-6-3l1 2 4 1-4 3-3-2v2h-12l-1-3-16 1-5 1h-10l-5 1-4 1-9 1-8-2-1 2h-7l-4-3-3-1-3-3v-2l-3 1-2 5-6-1v-2h-2v-3l-8-2-1-5 1-7-7-1v-7l-1-3-2-1-1-3-2-1v-2l-5 1-5-4-4-2 4-6 4-8h2v-2h-24v-1h41l17 3 9 3 2 4 5 3 3 3 4 8 1 3h15l1-4 1 3 7-1 1-2 1 1h10l14-2 8-5 2-6 9-3 13 2h3l1 3h2v-2l6-5 6-3 11-3 5-2 5-1z",
    fill: "#31353E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(878,878)",
    d: "m0 0 4 2 2 4 3 1v80l-12 1-5-2-3 7-6 2-4-3-2 4-7 1-1-2-5-1-4 3-6 2 4 2v2h3l-1 3h-2v3l-3 3-6 1-6 3-10 2-4 2-14 3-7 3-19 5h-7l-4-3-2-6v-5l-3-2v17l-7 4-10 4-9 1 2-2 10-5 1-5 2-1 2-7 5-5-1-8-3-3v-8l3-3 2-5 7 2h7l8-4 9-3 10-2 4-2 11-1 13-3 4-1v-5l3-5 2-7h9l2-4 9-2h6l-1-7-3-1-3-6 3-7 2-1 1-8 4-2-3-6 7-2 4 1 2-2h3v-3l7-2z",
    fill: "#B0B2C0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(428,302)",
    d: "m0 0 1 2h6l5-2h7l1 2 7 1 1 5-1 2 14-1 5-1 12-1 5-1 5 5 3 6 2 1-1 9 2 1h-2v2h-15l-6 1 4 4h9v4l-5 3h-2v2l-5 1h-4l-14-2-1 3-2 2v5l-4-1-5 2-4-1-1 2h-5v3h3l-2 5v5l3 1v2l-5 5h-2l2 4-1 5-4 1-2-2-5-1-1 6-7 1 4 2-2 4h-2l-2 6-8 4-1 3h-2l-1-4h-3v2l-10 3h-8v-4l1-2-6-1 2 5-9 1-1-5 8-11 6-8 5-5 1-2h2l1 14 2-12v-12l-4-12-6-9-2-6-5-9-9-9-10-7-10-4h-6l1-4 6-1 1 3 6-1 22-1 2 2v5h17l2 2h11l3-6 9-6 1-2h3z",
    fill: "#D9DCE5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(288,419)",
    d: "m0 0h8l4 1-1 4-5 5-3 1-1 3-3 3 11-4 2 6 5 1-1 3-7-1-2 7v5l-4 5-2 8 1 5h2v3l3 1 2 8-1 1v8l2 5 4 3h3l3 12 2 5 7 4 5 6 5 3 1 2 3-1v3l3-1v2l3 1 1-2h2l2 7 6 3h7l4-1 1 5v8l-1 3 1 2 6-3 2-7 8-1 1 3v22l1 6h4l2 11 3 3 1 9-2 1 2 9v3l5 10 5 5 5 6 3 2 4 8 9 7 5 2-1 5-2 1-4-4-2-1v-3h-5l-15-10v-2h-2v-2l-3-1v-2l-3-1v-2l-3-1-1-3-4-4-9-14-2-6 3-1-4-9-4-4-2-5-4-4h-2v-9l-4-2-4-7-2-1v-4h-2l-1-6h-5l-3-4v-5l-2-1-1-3-2-1v11l1 4-5 7h-2v-3h-2l-2-10-1-8-4-1-2-5-1 5-5 1-7-5 1 5v15l1 13 3 8v4h2l4 5 1 12 6 19v5l-2-3-4-8-4-11-1-3h-2v7l-4-4v-3h-3l-3-4-2-7-5-12-4-2 2-2v-3l-1-7-1-3 1-7-2-3 2-4-1-8 1-3h2l-3-13v-3h-3v3h-2l-2-6 1-1-2-11-1-5 3-7v-23l-2-5h-2l-1-4 3-7h-3l1-5h2v-6h2l2-5 1-3h2l1-3 5-1v-3h-2z",
    fill: "#30343D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(295,319)",
    d: "m0 0 19 4-5 5-4 5-4 10-1 5-1 20-2 5-3 1-8-6 4 6v4l-4 1-20 1-4 1v2l6-2h16l10-3h5l2 7h-2l-1 3-6 1-9 3-7 5h-2l-3 9-6 7-4 5-6 5-4 8h-3l1 5-1 2-5 1-4-10-9-2v-2l-2 1-1 5-12-1-3-1-1 4-10-1-6-4h-2l-2 4h-7l-3 3-11 2 1-4 5-4h2l1-3 8-7 5-5 9-11 7-10 7-11 4-5 15-10 9-7h2v2l-3 3 2 1-5 6-5 3-1 2 10-6 5-4 7-8 3-2-1 5-4 9-1 2 6-8 7-15 8-10 7-11 5-5z",
    fill: "#D8DBE4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(347,765)",
    d: "m0 0 7 1 2 3 5-1v2l9-1 4 4v2l16-2 8-3 1-1 7-1 5-1v3l4 2-15 5v2l7 1h6l-1 3-8 4-7 3-1 1h7l11-3 5 1 4 6 1 4 6-1 4 2-2 2 9-2 1-3 3 1v3l2 1-15 3h-5l-5 2-13 1-6 3-9 1-3 2v-2h-2v2l-4 1v-2l-12 6h-3l2-3-11 6-6 4-4 2-3-1 1-2h3v-2h-2v-3l7-3 5-4 1-4-5-1-9 5-6 2v2l-5 1-1-3-14 7-16 7-9 5-3-1 2-5 1-3h3l-3-5-1-3 1-2-2 1h-9v-7l5-4 2-5-2-6-4-2-6 3h-3l-2 4-7-1-7 8h-9l2-6 2-3h2l2-4h2v-2l4-1 2-4 4-4 2-3 9-1v-2l4-1 2-4 10-3h4l-2 5-3 1-2 4h-2l1 7v5h-2l2 4 10-3v-6l9-4 4-1v-2l9-3 4-2 1-4 4 1 1-3z",
    fill: "#31353E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(110,151)",
    d: "m0 0 3 1 3 5 2 19v6l-5 15h2l2-5 1-2h2v-2l3-1 1-5h2v-3l3 1-2 5-5 10-6 11-4 1-7 14h-2v5l-3 9-2 7-7 17-1 5-2 7-2 3 1 3-1 5-2 4-6 7h3l1 8-1 5-3 1v-12l-3 6-3 17v10l1 4-2 3v10l1 6 4 1 2-2 4 2 4 4 3-5 5-10 1-4h2l2-8 4-9 5-9 3-7 10-19 13-24 7-10 6-11 3-5 2 1-6 12-8 14-12 23-8 13-4 10h-2l-1 6-8 16-6 15h-2v7l-4 7v7l-4 5-3 8 1 5 9 5 8 4 7-2-2 4-12 2-9-4h-7l-4-2v-2l-3 1-8-5-2-5-3-3v-2h-3l3 7 7 8 11 5 6 1 1 3-1 1h-10l-11-7-3-4-4-1 1 5h2l3 4v3h2l1 3 15 6h2l1 2 18 2 16 1 6 2 2-5h5l1 3h7l4-3h7l1 4-4 4-4 1v-2l2-2-4-1v2l-13 3h-7l-4 2h-9v-3l8-2-2-1-18 1-4-3-3 1-2 5-5 2v-3l2-2-4-1h-5l-8-6v-2h-3v-2l-3-1-1-4-6-11-4-16-2-5v-6l-4-1v-2h4v-15l1-12 2-6 2-17h2l3-11 7-20 4-4h2l3-10 7-12 4-10 3-8 7-13 2-8 3-10h-2l-1 6h-2l-1 4h-2v3h-2l2-7 6-10 10-20 2-12 3-2v-10z",
    fill: "#31353E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(699,616)",
    d: "m0 0h6l3 2-1 3 13 3 6 2v2l-10 1-1 5-8 3h-8v2h-2v2l5 1 5 4 3 1v2h3l1 3-15-6-5-1h-5l-1-2-1 5 4 3h-3v2l-2 1 3 1h12l4-1 2 4-12 2-1 2v-2l-12 3 2 2v6l-8-2v-3l-3 1-1 2h-3l-1-6-7 2 1 5-4 1 1 8h3v5h2l-2 7-3 1-5-2-5-3-19-3h-3v-2l-2 1h-9l-11-1-1-4h10v-2l4 1v2h2v-3h3l-4-5-1-2-4-1v-2h-5l-4 5-2 5v5h-5v4h-2v-5l-2-1 4-1 2-6 2-5-7-2h-5v5l-5 1-2 7-12 1-6-2-1-7 1-8 6-5h2v-3h-2l2-4h2l-1-4 6 1 1-4h-2v-2h5l9-5h15l2-6h4l-1 4-2-1v2l5-1 4-3h9l3-2 6 1 1-3 7 1 2 2 4-1 1-3 3 1 1 4 5-1v2l5-2h3l1-2h6v2l10-3h3l1 5 6 2v-3h4l1 2h5v-3h2v3h2l2-5-12-3h-7-1v2l-3-1v-2l-4-1-3 1v-3l5-3z",
    fill: "#6F7381"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(53,746)",
    d: "m0 0 5 5 3 7-1 2h2l2-4 2 3 3 1-2 4 4 1 1 2-2 1 6 3 1 4h2l2-2 5 4h-2l1 2 7-3 9-1 2 1-2 5-6 4h-2v2l-14 10-11 8-5 1-1 5-11 1-5 1v-2l8-4 5-3 6-5 3-1 1-2-10 3-12 6h-2v3l-6 1-1 6 1 2-4-1h-3l2-3-6-2v2l-1 6 4 1 3 6v3l3 1 4 5-2 5-4 1-1-2h-4l-1-3h-4l1 5-10 1-3-1-8 3h-2l1 7v4l-4-1v-100l6-2 6 2h2l2-2 2 2 2-1 3 1 5-2 2 2 2-1v2h2l1-3 3 1v-2l10-2 2 1z",
    fill: "#6F7381"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,1141)",
    d: "m0 0 20 1 7 5h9l3 5 4 1h7l4-3h9l2 1 1-5h3v-2l6 1 1 3-1 2h2l1 3-3 12-8 14-20 25-14 8-10 3-21-2v2l2 1-2 1-14-1-4-2 2-1-6-2v-1l19 1h19l9-2 9-7v-1l-25-3-17-5-2-1 1 3-18 7-9 4-2-1 5-5 15-6h4l1-2h2v-2l-5-2-6-4-12-11-3-4v-7l6-12 3-3 10-3 5-1 2-1z",
    fill: "#31353E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(837,401)",
    d: "m0 0h9l3 1h7l1 3 10-1 2 1v3l17-2 1 1v31h-3l-1 4-5 2-3 4-12 3-5 3-8-1h-12l-2-1-1 4 5 2 6 3 9 2 2 1-1 5-4 1-2 8h-6l-2 5h3l1 4-8 8-4-2-2-3-6-3-1 4h-2l-1 3-4 1-3-5v-5l5-1-3-5-4-6v-8h3l-1 5h11l3 1 9-1v-4h-2l-1 4h-5l-2-6-1-9-6 4h-11v-2l2-1-2-6-5-2v2l-7-1-2-1v-9l6-4h2l2-5h-2l-1-5-3-2 1-4 4-1 5 5v-6l14-9 5-6h6z",
    fill: "#D9DCE5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(510,1075)",
    d: "m0 0 4 2 1 7h2l1 2v11l-1 5-3 3-1 4-1 9-2 1 2 11-1 5v1l-12 1-24-2-23-5-19-2-12-5-7-3-16-10-5-5 1-3 10-2 4-1h10v-2l11-3 6 1 7-1 1-3 15-4 8-1 7-4 20-4 12-2z",
    fill: "#30343D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(121,947)",
    d: "m0 0h22l9 1h31 3 6l2 1 6 10 1 3 7 6 1 3-3 5-1 2-17 4-3 5-7 1v-2h-7l-5 3-11 3-18 1-8-1-9 1-4 3-6 1-7-1-5-5-3-4-5-1v-2h-2l-2-4h-1l-1-9-1-6 5-1 4 2v-3l-1-3 5-5v2h3l1-6 9-3z",
    fill: "#17181C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(90,897)",
    d: "m0 0h3l1 5 2 6h9 4l6 3 5 2 3 3 5-3 3-1 1 3v1l7-1 5-2 8-3 12-2 8-4h2l1-3 13-1-3 3-13 5-7 5-6-1-3 1-1 3-10 2-10 5 2 2v-2h2l2 6 8 3 3 3 3 1 1-2 1 3h-2v2l7-1v-3h5l1-5h3v2h3v3l3-2 4-1 6-2h6l-1 4-7 4-2 5h-6l-4 2-3 3h-13l-9-1-6-2-5-1v2h-7l-4-3h-3l-3 3-8 1-5 1-14-1-10-3-3 1h-27l-2-1v-7l-2-6-10-1-10 2-10 3-5 1-1-3-8 2h-5v-5l6-2 30-7 11-4 1-3 6 1 3-5 2-1h10l10-3 4 1-1-6 3-1 2 2 4 1z",
    fill: "#6F7381"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(822,786)",
    d: "m0 0 9 3 5 5 5 3 4 1 2 4 4 5 6 4 3 6 3 1v3h-2v9l-1 3-5 3h-2v2l-10-1-5 1-2 4-5 3h-18v4l-8 1-7 5-3-3-3-1-1-3-6 2 3 1-2 4-5-1-3 5-7 2-4-6-2-1v2h-3l2-4 2-3h2l1-5 3-4h2l1-6 4-2 3 3 4-1 2-7h-3l-1 4h-3-2l5-10 4-3 12-3h2l1-3 4-1v-4l3-2 3-1v-2l4-2h3v2h2l1-3h2l-3-7z",
    fill: "#D9DCE5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,1410)",
    d: "m0 0h4l1 3 4 4 1 2h2l1 5 1 1v9l2 3v3l2 1-4 2 2 2-3 13h-3l-1 8-6 5-7 3-8 3-7 3-17 5-9 3-10 4-7 2h-5l-1-4 3-12 4-5 4-10 4-12 3-1v-5h2v-2h3l2-5 1-3h2v-2l3-2 4 1v8l-6 1-1 2 6 1 7-1-1-2-2-1v-7h4l-1 5 7 1 5-1 2 3 5-1 4-5 2-1 1-3 4-2v-3l-2-1 1-11-3-1z",
    fill: "#17181C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,1285)",
    d: "m0 0 4 2 9-1 6 2 4 4 3 9 8 2v2h-2l-2 7h2l1 3-1 3-6 1-2-1v2h-2l-2 4-3 2-7 2-5 2-9 1v2l-12 3h-3l-1 4-10-1-18-3-10-3-1-3h2v-2h2l1-9 6-4v-7l3-1v-2l3-1h9l8-2 3-2 5 1 1-4 3-2v-6l5-3 6 1z",
    fill: "#31353E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(149,260)",
    d: "m0 0 1 2h17l3 2 6-1 9-3 2 1h13l5 1 10 1 2 1v2l6 1 2 1v2h5v2l9-2 2 4 4-1 3-3 11-2h2l4-1 2 2-2 3-7 2-5 3h-3v2l-5 3-7 7-8 7-3 3h-10l-2-1v-2h-10l-7-3-5-4h-2l-3 3-3 2h-6l-3 4-16-2-1 3h-2l-2-9-4-2v-5l-3-1v-2h-3v-5l3-5-2-4z",
    fill: "#AFB1BF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(295,917)",
    d: "m0 0h17l3 3v2h6v3l-7 3-5-1 1 4h-8v3l-7 1-1 1h-12l-2-1v2l-10 2-1 5 1 1h8l6 1v2l-5 2-1 2-4-1-3-3v5l3 2h-2l-1 3h-3v2l-8 4-4 1-3 1-1 3-4 3h-6l-7-2-6-2 1-6-7 3-8 2-3-1 1-4-5-2 2-1 1-4v-3l-2-2 3-1 2-6-10 1-1-5 2-2h3v-2l7-1 8-3 2-4 8-4 4 1v1l13-1v-2l11-1-1 2 6 1 1 3h9v2l3-1 2 2 1 2 4-1 2-3v4h7l-1-3 1-4-3 2-4-1 1-3 3-3z",
    fill: "#18191E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(150,235)",
    d: "m0 0 2 1-6 12-8 14-12 23-8 13-4 10h-2l-1 6-8 16-6 15h-2v7l-4 7v7l-4 5-3 8 1 5 9 5 8 4 7-2-2 4-12 2-9-4h-7l-4-2v-2l-3 1-8-5-2-5-3-3v-2h-3l3 7 7 8 11 5 6 1 1 3-1 1h-10l-11-7-3-4-4-1 1 5h2l3 4v3h2l1 3 15 6h2l1 2 18 2 16 1 6 2 2-5h5l1 3h7l4-3h7l1 4-4 4-4 1v-2l2-2-4-1v2l-13 3h-7l-4 2h-9v-3l8-2-2-1-18 1-4-3-3 1-2 5-5 2v-3l2-2-4-1h-5l-8-6v-2h-3v-2l-3-1-1-4-6-11-4-16-2-5v-6l-4-1v-2h4v-15l1-12 2-6 2-17 4-2-2 13v17l2 7 4 4 1 6h2v7h2l2 5-1-10-3-7-1-7 2-3h2l2-14 3-7 2 4v5l1 4-2 3v10l1 6 4 1 2-2 4 2 4 4 3-5 5-10 1-4h2l2-8 4-9 5-9 3-7 10-19 13-24 7-10 6-11z",
    fill: "#31353E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,665)",
    d: "m0 0h6v3l6 3 2 5h-3v3h-2l-1-2-3-1v2l2 1-12-1 1 3 11 1h11v2l5-1 7 2-1 4-2 3-7-2-3-1-1 2-3-3v-2h-2l1 4-2 1 1 5-1 2 4 2 7 4v9l-5-2-5-3-10-2-2 5-3 1 1 4 10 7 3 3v3h2v2l4 1 5 4 8 3 1 5-13 7-10 7-3 3-15 9h-3v2l-3 1-4-1 1-3h2v-2l5-3 4-4 6-3 2-3-8 1 1-7-3-5-1 7-3-4-3-6-1-9-6-21-2-10-1-4v-4l10 1h9l3-3-3-3v-2h-2v-4l3-1 2 1-1-5 4-8zm-10 90 2 1-1 3h-2z",
    fill: "#333740"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,1017)",
    d: "m0 0 4 2 3 8 3 17 1 23 1 3 1 18 1 7 1 1v10l2 14 3 26v13l2 11 3 26 1 9 2 19 1 3v14l2 9-1 24h-3l1 7 4 2 2 5 5-1 5-5 3-5 13-4 4-2 12-3 8-3 13-4 10-1 3-1 7 2 2 2-1 6h3l2-3 4 1 1 2 5-6h5l1-5h2v35l-1 2-3-1-3-5v-2l-3-1-5-4 1 6v7l-2 1-3-4v-2h-2v-2l-3-1-3-5-1-6-3-5-4-2-1-3-3 3-9-2-6 2 1 4-4 1-5-2-7 2-6 1-9 3-2 6-4 2-1 2-5 2-1 1v14l-2 5h-2l-1 3h-3l-1-2v-7l-3-9-2-4v-3l-6-1-14 1-2 1h-9l-1 3-9 1-1-2 2-3 11-2 8-3 5-3 1-2 5-2 3-1v-2h2l-1-3 3-13v-7l-1-3v-18l-2-6v-13l-4-15-1-13-2-20v-16l-2-21-4-16v-3l1-2-4-16-1-12 1-2-2-5v-16l-3-13-2-4-2-7-2-4-5-1v-2l-21 3-24 5-10 2 1-3 7-1 8-3 12-3 8-3h6v2l9-2h12z",
    fill: "#B0B2C0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(78,669)",
    d: "m0 0 6 2 2-1 1 3h-2v2l7 1 10 1v2l2 1h-3l-1 2-6 1-2 2-4-1-3-3 1 5-5-2v-2h-2l-2 5h2l-1 3-5-3-1 2-5-1 1 2h4v5h10l5-1 4 1-3 1 3 1-1 3h-5l-2 6-9-1-4 1h-8l-4-1v3h-6l-2 4-4-1-1 2-8-1 1-5-4 1-2-1-1 3-13 1-3-1v2l-6 1-4-2-1-2-4-1v-18l9-1h3l1-2 5-3 2-3 5-3 6-4h22l12-2 10-1z",
    fill: "#18191D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(10,243)",
    d: "m0 0h1l2 6 3-1h3v2h2l-3 12-4 4 1 4 4 5 1 4-1 6v10l2 3h3l1 4v10l-1 19 1 5 4 24h-2l3 12 5 2 1 4-5-2-13-9-10-9-4-6v-2h-2v-3h-2v-95l5-2z",
    fill: "#AFB1BF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(532,1368)",
    d: "m0 0 10 1 12 6 12 5 10 5 13 4 6 1 5 3h3l1 4 7 1 9 4v3h-4l1 5 4 2 5 3 5 1v8l-5-1-1-3h-11l1 3-1 2 1 4h-2v-2l-4 1-1 2-6-5-4-4-2-1v-3l-5-1v-2l-5-2-10-7-7-4-7-3-7-2-7-5v-2l-5 1v3h2v2l4 1v2l5 2 10 8v2l3 1 6 9-5-2-5-5-8-7-8-4-5-1-8-4v-2l-6-2-7-5-1-5 4-6 3-7z",
    fill: "#17181C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(514,1212)",
    d: "m0 0h33l-2 2-3 1 1 1 25 2 1 4-6 17-2 7-11 5-7 2-20 1-18 5-14 8h-2l-2 4-4 1v-4h2l-1-4 2-1v-8l3-5 5-4h2l2-8h2v-2l6-3h4l1-3 6-2 8-3 5-2v-3l-5-2h-7l-4-1-1-4z",
    fill: "#17181C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(63,966)",
    d: "m0 0 4 1 2-1-1 4-3 3h-2l-1 10h-2v-2l-6 1-3 3-6 2v4l17 3 9 1 1-2 4 1v2l7 1 5 1 7 1 5-1 55-1 1 4-10 1h-12l-20 1h9l11 2h27v3h-7l-2 1-20 1-16-4-6 1-5 1h-15l-42 1h-16l-12-4-8 1-1 3-5-1-1-3-3-1v-2h3v-2l-5-2v-6l7 2 7-1-1-4-3-5-2-2 4-1 1 4 9 1 2 1 1-2 3 1v-2l19-10 4-5 5 1 5-2 1-1z",
    fill: "#6F7381"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(65,796)",
    d: "m0 0h4l-1 3-5 3-4 3-7 4-6 2h4 12l-3 1v2h-7l-4 3-1-2-3-1v6l-6 2 1 4 5 2v4h2l2 4-1 5-1 2-7 1v3h-10l-1-3h-2v4l-6 5-3-1 1 2 5 2 1 2v3h-3v5l-3-1 1 5h2l-2 6-2 1v-2h-2v3h-2l-1 3-6 1-2 3 3 1 10-1h19l1 5h6l-1 3v1l2 1v-6l7-1 1-1 7 1-1 4 3 1v2h2l1-2 2 2v-5l-5-1v-2l5-2 1 4h3l3 4 8-1 1 2 6-1-2-3 3-1 2-4v5h4l-1 4-10 3-6-2v3l-5 2-4-1-2 4-5-1-3 3-14 1 1-2h2l1-3-10 3-4 2 1-7 1-2-7-1-6-2-18 3-3 1v-2h-3v-42h4l-2-8 4-4 6-1 2-2 2 2h6l2-2 1-3 6-1-1 3 3 2 1-2 2 2 3-1 1-6-3-1-3-3-3-6v-3l-4-1 1-6-2-1 3-2 6 2-1 4h3l1-4 1-3 6-1v-3l16-8z",
    fill: "#32363F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(497,262)",
    d: "m0 0 5 4v2h2v2h2l-1 2h-3l3 3 1 5 6 4 1 5 4-1v-2l4 1 1 2 3 1v8l4 4 6 1v8l-4 2-4-3-1-3-2-2v-4h-7l-6 7-6 1-5-2-7-2-2-1h-11l-4 1-5-3-5-2-8-1-1-4 1-8-1-2 2-9-1-5 4-1 1-3h2v-2l6-2v2l7-1 8 3h6z",
    fill: "#707482"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1141)",
    d: "m0 0 10 3 10 4 5 5 4 13v2h2l-1 3-7-1-7-2-1 11-4 10-3 5-7 11h-2v2l-5 5-9 10-7 6-7 8-6 7-1 2-4 1-3-3-3-1v-7l4-6 12-13 3-3 1-4 7-8h2l2-5 6-7 5-10v-13l-1-8-1-4-2-1v-5h2l2-4z",
    fill: "#31353E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(375,951)",
    d: "m0 0 5 1 1 4 3 1 2 3 11 1 15-3 6-1 18-1 7-1h11l1 5-3 2-5 1-5 2-7 2-8 2-13 3h-3l-3 3h-6l-8 3-1 2h-9l-7 3-12 2-5-1v2h-3l-1 3h-7l-6-1-3 2-4-1 2-5 5-3 1-6 5-4 6-8 8-8h6l1-2 4-1z",
    fill: "#30343D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(124,1090)",
    d: "m0 0h6l3 2-1 4-2 4-7 3-10 4-4 2-8 3-15 4h-6l-3 3-13 3-4 1h-8-4l-3 3-5-1v-2h-3v2l-11 1-4 1h-20v-2h3v-2l10-4 6-3 9-3v-2l8-2 7-3 5-3 9-1 10-5h6l6 1 7-1 5 1 3-4h20l-1-2z",
    fill: "#31353E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,353)",
    d: "m0 0 5 5 9 11 7 6 4 4 6 5v2l5 1 2 1v2h2v2l4 2 7 10 7 6-1 6 6 1 5 4-2 4-4-2-6-4h-11l-11-1-5 2-4 1-3 2-9-11-4-4-2-10-7-13z",
    fill: "#D8DBE4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(620,686)",
    d: "m0 0h2l1 4 6-1 7 2 1-2 9 2 5 5-2 7v2l6-1v11l-3 3-4-2v-2h-3l-1 5 4 1v3h7l2 2-2 4 1 11-3 5-8 1-6-8-7-2-6-4-6-5v-2l-6-2-9-7-1-4 4-1 2-5 10 1 10 6-1-9-10-6v-6l-1-2h3z",
    fill: "#17181C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,1270)",
    d: "m0 0h6l-5 4-7 6-1 6 7-1 4 2 4 1-1 7h2l1 3-2 4-5 1-3-6-4-6-5 1-2-4-3 3v4l-1 10 3-1v2l10-2 1 2h4l1 7-5 6 1 4-1 1 4 3 6 1-1 5 6 1 14 3 12 2v2l-11 2h-5v2l-5 2-8-1v2l-4 1v-4-5h-2l2-4 1 1 1-2-4-2-18-1-6-2-2-1v-2l-10-2-23-4-7-4-1-3 6-2 4 2 7 1 6 3 12 2h5l-1-5 1-4 3-5-7 1-2-7v-5h3 2v2l2-2v-6l2-1-1-7 4 1 3-4h2v-4z",
    fill: "#31353E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(39,929)",
    d: "m0 0 10 1 3 9-1 5h29l4-1 7 7-3 2-3-1-3-3v2l-4 1v-2l-3 1 2 1-2 4 2 2-10 4-7 2v-2l-5 1-6-2-3 1-1-3 4-4-11-1v-2h-3v2l-5-2-2 4h-3l-1 2-4-2v2h-2v-2h-2v2l-4 2-4-4-3-1-1 5-4 2v-26l13-2 2 2 9-2 5-2z",
    fill: "#18191E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595,1123)",
    d: "m0 0 4 1-1 7h-2l-2 6-4 3-6 2 3 3-3 3 1 1 7 1v8l-2 5h-8l-3 7-3-1-1-6 4-2-1-2-17 1h-14l-17-1-1-2 1-2h-2l-1-4-3-1 4-7 11-3 6-2h4v2l4-1h6l6 2 1-2h3v-2l-2-1 3-1v2l2-1v-3l5-3 7-2 7-4z",
    fill: "#30343D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,998)",
    d: "m0 0 5 2v2h-3v2l4 1v3h5l3-3 6-1 12 4 18 1 6 1 1-1h6l-1 2 3 1v2l3 2h-3l2 4h-8l-3-1h-3l1 4-7 3-1 4-6 1-1 1-7 1v2h-2l-1-2-2 2-4-1-3-3h-6l-3 4h-6v-6h-5z",
    fill: "#17181C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(886,560)",
    d: "m0 0h1v33h-4l-2 3-2-1-5 1v-2h-2l-1 2v-3l-2-1-2 2-4-1v2h-5l-1-2-3-1-1 3h-2l-16 1-4-2v-2h4v-11l-1-3 6-2h11v-2l5-3 3-4 9-1 3-1 1-3z",
    fill: "#18191E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,497)",
    d: "m0 0 5 1 7 4 3 3v3l5-1v3h-2v3l4 1 2 7-2 6v14l-2 8-1 3v17l-2 3h-5l-5-5-2-7-5-4z",
    fill: "#D8DBE4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(554,1204)",
    d: "m0 0h3v5l7-1 1-3-2-1 5 1 5 5-5 3h-8v2h-2v2h5v-3h3v2h4l3 3 4-3 9-1h30l14 1v-3l18 1-1 2-24 9-14 3-11 2-12 6-12 3v2l-11 3-2 1 1-6 6-17v-3l-25-2v-1l9-1 3-2-4-2v-4z",
    fill: "#18191D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(364,775)",
    d: "m0 0 3 2-1 2 7-2 4 1h-2v2h-3l-1 3 7 3 7 1-1 2-5 1v3h-2v-2h-2l1 3-5 1-1 3-5-1-4 4-16 8h-6l-1-3-2-1-1 5-3 2h-4v-2l3-1-2-4-6 2-2-4-3-1 1-3 10-5h3v-2h-4l-1-2v-6l3-2 17-4h6l6-2z",
    fill: "#6F7381"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(99,219)",
    d: "m0 0 1 4-2 10-3 6-2 10-5 12-3 7-6 17-3 9-3 1-1 6-3 8h2l-2 16-2 7-2 8h-2l-1 5 3 9 2 8v6l-3-2v-4h-2v-7h-2l-1-6-3-1-2-2-1-7-1-5v-13l3-14 2-4h1l1 11v16l1 3 3-3-1-3 1-17 3-16 8-24 5-13 7-17 5-9 7-11z",
    fill: "#17181C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(209,306)",
    d: "m0 0h17l-1 3-8 7-10 10h-2v2l-14 9-12 2-4-2 3-3 17-7 10-6-5 2-16 7-13 5h-5l-2-2-2-12v-6l17-5z",
    fill: "#6F7381"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(345,932)",
    d: "m0 0h3v3h3v3l2 1-1 2h-2v2l-7 2 1 4 2 2-2 4-4-2-1-4 2-2-5-1-3 3v3l-1 6-5 3-12 3h-3l-4 1-4-1v-3l2-1-1-3-3-2-1-1-2 3h-3v3l7 2-2 2-3 1-1 2-6-2-1 3-3-1-1-5h-2l-1 7 2 1-9 3-1-2-11 2-2-1 1-5 2-2 9-2 1-4 6-3 8-5 1-2 12-4v5h4l-1-3 1-3h7l4-2h6l-1 4 1 4h2l1-7v-2h5l3 1 5-6h2v-2h4z",
    fill: "#17181C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(442,802)",
    d: "m0 0 16 1 7 3 3 3v2l-9 4-23 3-12 4-11-1h-10l-10 2-11 3h-12l-3-3h4l-1-3 12-7 7 1v-2h4l4-2h6l7-3 12-1 6-2 9-1z",
    fill: "#6F7381"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(466,1328)",
    d: "m0 0 5 2 7 5v2l5 2 15 9 11 6 1 2-1 3-14 5-3 2-9 1-13-1 1-5-6 1-6-3-2-4 1-6 2-7 3-5 4-1-1-2z",
    fill: "#17181C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(819,521)",
    d: "m0 0h7l4 6 8 2 1-4 4-3 14 1 2 2v4l-8 2h-8l-11 2-7-2-18 2-18 1-15 3-1 2 5 2v3l-4 1v3l-4-1-1-2-6-3-7-2-1-5 3-6h2l1-5 9-2h47z",
    fill: "#B0B2C0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,930)",
    d: "m0 0 7 1v28h-7l-7 3-13-1-10 1-9-2-5-8 2-3 6-1 1-4 5-3h11l2 1v-2h3l-1-5 13-2v-2z",
    fill: "#DADDE6"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772,596)",
    d: "m0 0 7 1v2l12 1v2h-4v2l12-1v-3l7 1 4-1-1 3v3l-13 1-9 2-2 4h-4l-1 4-6-2-6 1-3-2-2 2-4-1-1 5v6l2 2-1 3h-5l-5 5h-3l-4-3h-6l-2-5 2-3-3-2v-2h2l-1-4-2-1 1-3 7-3 2 1v-2h9l10-1 1-4 5-2 1-4z",
    fill: "#6F7381"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(220,672)",
    d: "m0 0 3 1v3h-2l1 3-2 7-4 12-4 1-5 2-2-1v2l-4-1v-4l-2 1-1-4-2 1 1 5h-7l1-3-4 1v-2l-5 2-4-4-5 1-3-3-2-4-1-5 6 1 1-3 6-2 16-2 3-1v2h2l1-3 16-2z",
    fill: "#6D717F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(655,210)",
    d: "m0 0 8 1 8 6 4 4 2 6-1 4-2-3-5-3-5-2h-4l-3 10 2 4 3 8-4 1-10-4-1-3-9-4-5-6 1-3-16-2h-9l1 2 9 4-3 1-15-3-11-1-2-1 1-3 11-4 9-2h11l13 3 10 3 5 3 3-1 1-2 1-11z",
    fill: "#6F7381"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(724,595)",
    d: "m0 0h13l4 6-1 3 3-1v2l-4 2h-3l1-5h-2v4l-7 3-7 1-3-1-1 2-9-1v-5h-2v5l-9-1-2 4-6 1-1 2h-11v-2h-5l-5-1-9 1-5-4h2l2-4 18-2 8-3 16-1 6-2 12-2z",
    fill: "#18191D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(333,312)",
    d: "m0 0 3 2 18 1 9 4 10 8 8 8 5 9 2 6 6 11 3 9v12l-2 13-2-1v-14h-2l-2 4-3 4-5 5-8 12-6 8-2 6-2-1-2-5-2 3h-2l1-5-2-1v-2l3-3h-10l-6-2v-5l4-5h2l1-4 4-5 8 1 3-4h3l2 15h3l1 2 8-11 4-7h3l2-5 4-1-2-9-6-12-3-3-3-7-2-6-7-8-10-8-10-4h-16l-3-3z",
    fill: "#757987"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,885)",
    d: "m0 0h4l1 5h6l-1 3v1l2 1v-6l7-1 1-1 7 1-1 4 3 1v2h2l1-2 2 2v-5l-5-1v-2l5-2 1 4h3l3 4 8-1 1 2 6-1-2-3 3-1 2-4v5h4l-1 4-10 3-6-2v3l-5 2-4-1-2 4-5-1-3 3-14 1 1-2h2l1-3-10 3-4 2 1-7 1-2-7-1-6-2-18 3-3 1v-2h-3v-10l5 2 7 1v-2l8 1 2-2z",
    fill: "#6E727F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(9,895)",
    d: "m0 0h18l2 2 1 6-1 2 5-1v4h-2v2h6l3 1v2l-7 1-9 3-2 2v2h-4-2l-2 4-9 1-2 2h-4v-32h3v2z",
    fill: "#17181C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(259,1311)",
    d: "m0 0 5 1-1 4 7 3 5 3 2 5-1 5-3 6-2 1-3 6-10 10-5 3-3 3-3-1-2-3v-5l4-6h3l-2-5 3-5v-7l-5-6 1-4 6-7z",
    fill: "#17181C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(134,808)",
    d: "m0 0 4 1v2h13l4-1 1 6v3l6 2-2 1-1 3-5 5-5 6h-2l-1-3h-6v-3l-3-1-1-3v3l-7 2-9 1v-3l-4-1v2l-6-1-1-6 8-1 2-9 5-2 6 1h2v-2h2z",
    fill: "#333740"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,652)",
    d: "m0 0 3 4 1 4 2 1 4 10 3 5 2 5h2l6 9 4 5 2 1v2h2l1 5 2 1v3 2l4 1 2 4 2 1 2 6 2 1v6l-2 1-9-6v2h-4v-2l-5 1v-3l-4-2-3-3-4-1 1-6-1-7-2-1-2-9h3l-1-5-5-7-7-18z",
    fill: "#343841"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(760,571)",
    d: "m0 0h6l5 4 1 2v11l30-3 4 11v2l-11 1-4-2-4 2-3-1-1-3-6-2-13 4-3 1-1 5-12 1-2-3v-3h5l1-5h2v-2l8-1-6-7-1-6 3-5z",
    fill: "#1A1B20"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(210,612)",
    d: "m0 0h11l5 3 4 1 1 7 3 9 9 6 1 3h-3l-11-4-4-6 1-7-4-1-4-3-11 2-11 6-3 4h-3l-2 4-4 4v4l-5-1-2 1v-2l-3 1-9-3 3-1v-2h-2v-2l4 1 1 1v-3h2l1-2 4-1 1-3 3 1v-3l4-4h4v-3h3v-3l6-1z",
    fill: "#1A1B20"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(567,929)",
    d: "m0 0h5v4h-2l-1 6-3 1v4h-3v4h2v2l-14 4-7-1-2-3h-2v5h-6l-3-2v3l-5 2h-6v-4l13-4-1-4-10-1 5-4 7-3h3v-2l16-4 5 1h3z",
    fill: "#31353E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,352)",
    d: "m0 0h3l1 6 5 1 9 1 4 1 1-1 17-1 2 1v2l3-1 1 3 2 1-3 6-6 2v-3h-5l-2-2-4 2h-9v2l-5 1v8l-1 2h-3l-1 2-5-3v-4l3-1 1-3-2-1-1-3-7-2h-6l-4-3-1 2-6-2v-1l10-3 1-2 6-1z",
    fill: "#707482"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(617,725)",
    d: "m0 0 2 1v3h2v2l4 1 5 4 8 3 1 5-13 7-10 7-3 3-15 9h-3v2l-3 1-4-1 1-3h2v-2l5-3 4-4 6-3 2-3-7 1 1-3 11-6v-4l-3-1v-5l2-5 4-3z",
    fill: "#6F7381"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(266,330)",
    d: "m0 0h2l-1 5-6 8-5 6 2 1v2l-4 4-7 8-1 3 7-8 2 1-8 9-8 6-6 2 1-3 6-4 3-4v-4h2v-2l-11 8-16 11-11 17-9 12h-3l9-12 12-18 4-5 4-4 1-5 9-10 14-11 6-4 11-8z",
    fill: "#707381"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,2)",
    d: "m0 0h28v27l-7-1-1-3h-9l-9-2-1-1-2-9-1-3 2-5-2-1z",
    fill: "#B0B2C0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(631,937)",
    d: "m0 0 2 1-5 5-16 10-11 7-9 3-9 2-4 4-3 10-7 21-2 3 4 2-6 2-2 10-4 10-4 13-3 9-2 9-3 8-2 3h-2l-1-6 3-9 4-10 6-16 5-16 1-4-2-2 4-1 3-11 6-18 3-12 4-8 4-3-1 10 19-8 10-6 9-6 5-2z",
    fill: "#B3B5C2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(29,383)",
    d: "m0 0 2 1v2l5 1 2 1v2h2v2l4 2 7 10 7 6-1 6 6 1 5 4-2 4-4-2-6-4h-11l-11-1-5 2-4 1-3 2-7-9 3-2 4-1 1-3 5 1 1 2-1 2 3-1v-2h2l1 3h10l-1-4-3-1v-3l-4-2-3-6-2-7-2-4z",
    fill: "#B2B4C1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(25,597)",
    d: "m0 0 4 1v2l5 2 4 4 4 2-1 4-2-1-6 6h-10l3 2v2l-10 2-4-2 3-8v-2h-4l1 3-2 4v-2l-5 2-4 1-1-1v-15l4-1 2 1 4-2h10v-2z",
    fill: "#AFB1BF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(340,582)",
    d: "m0 0 4 2 4 1-1 4 3 1v3h2l3 10h2l-1 6 2 2 4 3 3 1 2 4 4 4-1 5-10 2-3-3v-2h-2v-3l-5-2-5-8-2-1 1-7-3-4v-4l-4 1-1-8-3-2v-4z",
    fill: "#30343D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(419,1206)",
    d: "m0 0h4l1 2 3-1 1 2v6l-8 8-6 5-7 8-6 7-1 2-4 1-3-3-3-1v-7l4-6 12-13 5-6 7-2z",
    fill: "#17181C"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(101,364)",
    d: "m0 0 4 2 8 8 9 3 4-1 7-7 9-5 7 1 2 4-1 5-5 3-8 1v2l-7 2-3 1-3 3h-2l1 4-2 3-5 2h-7v-8l-8-4v-2l-4-2-3-3 2-4 12 7 9 1-13-9-3-5z",
    fill: "#32363F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,1017)",
    d: "m0 0 4 2 3 8 3 17 1 23 1 3 1 18 1 7 1 1v9l-3-1-4-16-1-12 1-2-2-5v-16l-3-13-2-4-2-7-2-4-5-1v-2l-21 3-24 5-10 2 1-3 7-1 8-3 12-3 8-3h6v2l9-2h12z",
    fill: "#B0B2C0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(518,1174)",
    d: "m0 0 8 1 12 6 5 4 1 5h2l4 7-1 9-6-2-3-2v-2h-2v-2h-3l-3-5h-4v-3l-6 1-7-1-2-2 2-2 1-4 1-1z",
    fill: "#2F333C"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(208,369)",
    d: "m0 0h3l1 4-3 5-12 9-18 13-14 11-4 1v-7l3-6 5-4 11-8 5-3 9-6z",
    fill: "#707482"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,1164)",
    d: "m0 0 2 1v10l-8 13v3l4 4 2 7v8l-4 6-6 8 5-2 1 4-6 8-1-3 1-2-5 3-3-1 8-12 2-4-5-2-1-9 3-2-2-2h3v-2l-6 1-4-2 6-8h2l2-5h2l2-5 5-12z",
    fill: "#30343D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(778,821)",
    d: "m0 0h2l-1 3h-2l-5 10-3 1-2 7-5 6-4 1-3-3v-2h-2v3l-3-1v-3l-4-1-3-4v-6l7-2 5 1 4-2-1-2 7-1v-2z",
    fill: "#D9DCE5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,260)",
    d: "m0 0 2 2 1 9 1 2h-2l2 39v12 3l-2 8h-2l-1 6-3-4-1-7v-27l2-23 2-13 1-2h-2l1-4z",
    fill: "#31353E"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,1058)",
    d: "m0 0 4 1v2l9 2v3l12 2v2l2 1-3 2v5l-2 4-1 4h-9l-4-5v-2l-5 1-3 3z",
    fill: "#17181C"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,175)",
    d: "m0 0 3 2 2 12-1 10-4 5-4 1-1 4h-4l-4-8-6-1-2 4-4-2-2-3 1-7 7-2 10 3 6-4 2-13z",
    fill: "#717583"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(554,1204)",
    d: "m0 0h3v5l7-1 1-3-2-1 5 1 5 5-5 3h-8v2h-2v2h5v-3h3v2h4l3 3 4-3 9-1h26l-3 2-27 1-6 2-4 15-3 6 5-1-2 2-9 2-2 1 1-6 6-17v-3l-25-2v-1l9-1 3-2-4-2v-4z",
    fill: "#31353E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,998)",
    d: "m0 0 5 2v2h-3v2l4 1v3h5l3-3 6-1 12 4 11 1v1l-9 1-1 2h-2l-1-4h-2v3l-7 4-1 2h-7l-1-3-2 3-3-1v2h-3v2l2 1-1 2h2v2h3v3l-9-2-1-1z",
    fill: "#31353E"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(505,955)",
    d: "m0 0 8 2v-2h4l2 3 4 1 24-4-5 6-1 2-15 2-13 1h-23l-1 3h-3l2-6 10-3h4v-2h3z",
    fill: "#D6D9E2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(529,890)",
    d: "m0 0 6 3 3 1v5l-4 1-2 4-13 1-4 1h-8l-3-1-1-5-4 1-2-1 1-5h2v-2l9 1 10 4v2l6 1-2-5-2-4 1-1z",
    fill: "#17181C"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,1211)",
    d: "m0 0h14l6 1v1h-9l1 3 4 1h6l6 3-1 3-6 4-7 2-1 1h-5l-1 4-7 1-3 1v2h-2v5l-5 5-4 2-2 5h-2l2-7 3-7 4-7 10-5 13-4 5-2h3l1-4-16 2-7 1v-2l4-2 1-2-6-3z",
    fill: "#31353E"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(188,400)",
    d: "m0 0h1v6h-2l-2 6-7 9-13 12-5-1-1-1 1-9 4-5 6-4h2v-2l11-8z",
    fill: "#D0D3DD"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(241,10)",
    d: "m0 0 4 1 2 4 2 1v2h7l5-5 7-1 3 4-1 6-3 1-3-1-1 1v7l-2 3-11-2-3-2-6-12z",
    fill: "#6C707E"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(31,1143)",
    d: "m0 0h5l1 2-3 5h-2l-1 3-1-2h-3l1 3-8 2-1 2-2-1v2l-5 3h-7l-5-1v-9l11-3 4-2 7-2z",
    fill: "#B3B5C2"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,1270)",
    d: "m0 0h6l-5 4-7 6-1 6 7-1 4 2 4 1-1 7h2l1 3-2 4-5 1-3-6-4-6-5 1-2-4-6 3-3-10 4 1 3-4h2v-4z",
    fill: "#2F333C"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(345,380)",
    d: "m0 0h5l-1 8h-2v4l2 1h-2l-2 4-2 6h5l1 1 10 1-1 3h-2l-2 5-6 2-1-4 2-2-7-1v2l-2 1 1 5 3 5-5-1-1-6-3-1v-7h2v-9l-1-4 3-1 1-5 3-3z",
    fill: "#333740"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(467,901)",
    d: "m0 0h8v2h2v-2h4v3l-3 1-2 4-5 1-3-1v2h-3l2 4-1 4-6 1v2h-5v-2l-4-1v-3l1-3-10-1 3-2-1-2 7-1v2l3-1 1-2 4 1 1 2 2-3-2-2z",
    fill: "#18191D"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,646)",
    d: "m0 0 5 1 5 2v15l-6 1v2l-6 1-5-2-3-4v-9h2v-3z",
    fill: "#17181C"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,1138)",
    d: "m0 0h7l6 2-1 3 4 1h26l5 2 1 4-2 2-2 1-1 3-13-3-12-4-9-4-13-5z",
    fill: "#30343D"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(755,373)",
    d: "m0 0 4 1 6 2 3-1v2l-3 3-2 5h-2l-1 5h-10l-1 4-5-1 2-5v-4l-3 1 1-10 1-1z",
    fill: "#707482"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(333,312)",
    d: "m0 0 3 2 18 1 9 4 10 8 8 8 5 9 2 6 6 11 3 9v12l-2 13-2-1v-14h-2l-2 4-3 4-5 5h-2l2-5 5-8h3l2-5 4-1-2-9-6-12-3-3-3-7-2-6-7-8-10-8-10-4h-16l-3-3z",
    fill: "#707482"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(473,1312)",
    d: "m0 0 6 2 7 1 6 3 12 3 11 2 15 4 2 3h-11l-19-4-13-3-12-2-7-4-1-3z",
    fill: "#17181C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(862,1312)",
    d: "m0 0 4 4 5 2 4 6 2 1-1 3h-2l-3 5h-5l3 3-6 1-2-4-5-3v-5l3-2h3l-1-2-7-1v-5h5z",
    fill: "#AFB1BF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(617,1117)",
    d: "m0 0 9 3v3h2l1-4 6-1 6 5v2l-6 2-5-1-1 3-15 5-5-1-1-4 1-2h4v-2h2l1-7z",
    fill: "#31353E"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(240,730)",
    d: "m0 0 9 1 13 4 11 6v2l-12 1h-13l-5-1-3-10z",
    fill: "#333740"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(275,285)",
    d: "m0 0 6 1 1-1 8 1 8 3 3 3 9 2 2 3h-7l-12-3-28-2-8 4h-2l2-4 7-4z",
    fill: "#707482"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(566,1111)",
    d: "m0 0 6 2 5 5 1 4-5 1-2 1-7 4-13 3h-5l-3-7 5-2 4 1v3l1-4 6-2 1 1h5v-7z",
    fill: "#31353E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(195,907)",
    d: "m0 0 3 1-4 3h10l-1 4-12 7-9 4-2 4-4-1 1-3h3v-3h-5l2-5 5-5 10-5z",
    fill: "#707482"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(699,616)",
    d: "m0 0h6l3 2-1 3 13 3 6 2v2l-10 1-1 5-4 1-1-2 3-5-12-3h-7-1v2l-3-1v-2l-4-1-3 1v-3l5-3z",
    fill: "#707482"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(133,440)",
    d: "m0 0 2 3 4 2v9l-3 5 4 2-3 2-4-1-1 3h-2l1 5 5-2v2l3 1-3 7-3 8h4l-3 10-2-4-1-4 2-13v-3h-2v3l-4-1v-4-7h2l1-13 2-2z",
    fill: "#2F323B"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(470,1389)",
    d: "m0 0h10v2l5-2 2 6-3 3 1 3-5 2-1 5-7-1-1-7-4-2-3-3 1-2 6-1z",
    fill: "#17181C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,977)",
    d: "m0 0 4 1 7 3 4 2-2 9-4 5-5-1-3-2h-2l-3-4 1-10z",
    fill: "#707482"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(165,341)",
    d: "m0 0h16v2h-3v2h8l-2 5-7 6-8 4-3-1z",
    fill: "#707482"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595,1345)",
    d: "m0 0 11 1 12 3v2l5 2 3 2 6 2 5 6 1 7-3 1-1-6h-2l-2 3-5-2 1-4h2v-2l-4-2h-9v-2h-2l-1-3-7-1v-2l-6-1z",
    fill: "#17181C"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561 1e3)",
    d: "m0 0 4 1-1 7-3 9-3 10-3 8-3 9-2 9-3 8-2 3h-2l-1-6 3-9 4-10 6-16 5-16 1-4-2-2z",
    fill: "#B0B2C0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(39,929)",
    d: "m0 0 10 1 3 9-1 5h32l-2 2-26 1-4 1-1 3-3-1 1-10 1-3-1-5h-12l-1 3-5 1h-11l-1 4-1-3-3 2h-3l-1-1-10 2v-5l13-2 2 2 9-2 5-2z",
    fill: "#31353E"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(237,650)",
    d: "m0 0 4 1v2l-17 5-6 3-2-1-1 5h-2v3l-6 2-5-6v-9h6l2 6 1-3 8-4 6-2z",
    fill: "#17181C"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(184,422)",
    d: "m0 0 2 2-3 1v3h2v2l4-1 2-3h5l4 3h5l5-4 6 1h3l6 1 1-3 4 1-2 1-1 5-12-1-3-1-1 4-10-1-6-4h-2l-2 4h-7l-3 3-11 2 1-4 5-4h2l1-3z",
    fill: "#B0B2C0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(484,1324)",
    d: "m0 0 8 1 2 4v4l3 1-3 6 2 2-1 3-1-3h-5l-10-7-3-4 4-3 3-2z",
    fill: "#6F7381"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(70,507)",
    d: "m0 0 4 1 1 3 6-1 6 4 1 6-4-1-1 3-9-3-4 2h-7l1-7 3-1 1-5z",
    fill: "#717583"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,1158)",
    d: "m0 0 4 2v7l2 1 3 8 1 4h2l2 6-5-1-13-12-2-3 1-5 3-6z",
    fill: "#191A1E"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(884,605)",
    d: "m0 0h3v11l-4 4-5-1-1-2-3 1-2-4h-5v2l3 3h-3l-8-7v-2h3 1l3-1 3 1 4-1h6v-3z",
    fill: "#18191D"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(198,389)",
    d: "m0 0h2l-1 6-11 16-4 5-2-1 5-9h2l-1-5-5 3-9 7h-2v2l-10 7-3 9-1-4 3-7 22-18h2v-2z",
    fill: "#707482"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(860,850)",
    d: "m0 0h3l2 5 5 2 2 8v5h2l1 4h-3l-3-5-4-3-8-1-3-5 1-4 4-1z",
    fill: "#AFB1BF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,762)",
    d: "m0 0 3 4h2l1 7 1 2h-3l-2 6-4 2-3 3h-6l2-6v-5l3-1-1-4 2-4h3z",
    fill: "#31353E"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(10,413)",
    d: "m0 0 4 1 10 16 6 7 10 3 1 5h-11l-5-4-5-9-6-9-4-8z",
    fill: "#272930"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,1248)",
    d: "m0 0 3 1-18 7-16 1-17-1-9 4-4-1-4-3h-8l-3-1 1-3 14 2h25l7-1 7 2v-2h7z",
    fill: "#31353E"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(673,694)",
    d: "m0 0h6l5 5v6l-5 4h-6l-4-4-1-4 3-6z",
    fill: "#D3D6DF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,665)",
    d: "m0 0h6v3l6 3 2 5h-3v3h-2l-1-2-3-1v2l2 1-12-1-1 2-1-4 4-8z",
    fill: "#333740"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,572)",
    d: "m0 0 4 1-2 1 1 8 4 3 8 2 10 1 1-3 6 1 4 1 1-3 5 1 1 2-4-1v4l-9-2-3-1-1 4-5 1-13-3-12-4 1-12z",
    fill: "#31353E"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2,1443)",
    d: "m0 0 1 2h2v2l7 1-4 8-3 2-1 4h2v9l-5 1h-1v-28z",
    fill: "#17181C"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(394,1315)",
    d: "m0 0h3l1 5 3 1v6h2l1 2 7 3-1 3-5 3-7 1-3-3 2-6-2-4v-6h-2z",
    fill: "#30343D"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(822,539)",
    d: "m0 0 4 2-3 1-1 2h-18l-4 1h-14l-7-2 3-3z",
    fill: "#B0B2C0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(630,1190)",
    d: "m0 0h13l9 3 10 3v3l-23-1-6-2v-2l-4-1z",
    fill: "#18191E"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(100,133)",
    d: "m0 0 9 2 8 5 1 3h2l2 3v9h-2l-1 2-5-9-7-6-8-8z",
    fill: "#B0B2C0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,399)",
    d: "m0 0 3 3 8 16-1 5-1-2h-2l1 4-4-1-1 3-3-1z",
    fill: "#D3D6E0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(287,270)",
    d: "m0 0h16l2 2-2 1-17 2-23 5-11 3 3-3 12-6z",
    fill: "#23252C"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,1387)",
    d: "m0 0 5 2 2 2-2 7 4 4-10 2v9h-2v-2l-3-1 1-2-2-1 2-6 2-7h2z",
    fill: "#707482"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(679,879)",
    d: "m0 0h5l-4 14-3 6-4 5-5 5h-4l2-5 9-15 3-9z",
    fill: "#B0B2C0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(877,652)",
    d: "m0 0 4 2 6 4v11h-3l-1-2-6-3-7-4-4-2 3-3 7-1z",
    fill: "#333741"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(114,1046)",
    d: "m0 0h2v2l4-1 3 2-2 6h-6l-3 2-1 1-1 3-3-1v4l5-2 1 4-6 2h-2l-1-2h-4l3-3-2-4 5-1 3 1-2-5 1-3 5-1z",
    fill: "#707482"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,866)",
    d: "m0 0 5 1v-1h5l-2 7h4l-1 3-3 2h-3l-1 2-3-1-1 5-5-2-1-4 1-3h2l1-6h2z",
    fill: "#31353E"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(623,379)",
    d: "m0 0h7l3 8-2 5-6 2-5-2-1-3v-7z",
    fill: "#B0B2C0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(631,937)",
    d: "m0 0 2 1-5 5-16 10-11 7-9 3-8 1 3-3 14-6 10-6 9-6 5-2z",
    fill: "#B0B2C0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(68,425)",
    d: "m0 0h5v2h-2l-2 4-11 8-11 5-1-7 14-7z",
    fill: "#1F2127"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(142,366)",
    d: "m0 0 9 3-1 5-5 3-8 2h-8v-3l12-9z",
    fill: "#707482"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(33,996)",
    d: "m0 0h2v2l7-1 16 3 6 1-4 2h-33l-2-4 3-2z",
    fill: "#31353E"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(368,820)",
    d: "m0 0 3 1v2l-3 1 2 1h12l13-4 8-1h10l11 2-4 2-5-2-1 3-2-1v-3l-6 2-12 1-5 2-9 2h-11l-12 2 3-5z",
    fill: "#31353E"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(187,1335)",
    d: "m0 0h9l7 1 1 4 3 1v3h-3v-2h-3v5l-2 1-7-3-2-2-4-1z",
    fill: "#31353E"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(122 1e3)",
    d: "m0 0 12 2h27v3h-7l-2 1-20 1-19-5v-1z",
    fill: "#707482"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(655,1209)",
    d: "m0 0 2 1-1 1 2 2-10 2-18-2v2l2 1-2 1-14-1-4-2 2-1-6-2v-1l19 1h19z",
    fill: "#31353E"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(623,797)",
    d: "m0 0h3l-1 6-5 5v2h-5l-1 3-5-3-1-8 10-3z",
    fill: "#17181C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(875,390)",
    d: "m0 0 5 2 7 1v10h-11l-5-4 1-4 2-1z",
    fill: "#707482"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,575)",
    d: "m0 0 2 2 2 8 5-1 3 4 2 7v6l1 4-4-1-4-9-2-4-4-1z",
    fill: "#31353E"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,337)",
    d: "m0 0h2l-2 4-9 9-14 9-10 6 1-4 7-6 11-8 6-4h2v-2z",
    fill: "#C5C8D3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(630,643)",
    d: "m0 0 8 1-5 4-1 12 15-1h4v3h-9l-10 1-2 6h-1l-1-6-12-1v-1l13-1 1-12-9-1 3-2z",
    fill: "#BEC1CD"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,1152)",
    d: "m0 0 4 2-2 3v4h-5l-3 9-3-1-1-6 4-2-1-2-13-1 1-2 9-2v2h2v-2l5-1 3 1z",
    fill: "#1E2025"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(36,388)",
    d: "m0 0h2v2h2v2l4 2 6 9 1 4-1 1h-5l-1-3h-2l-2-4-3-1-3-8h2z",
    fill: "#D8DAE4"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(438,284)",
    d: "m0 0 9 1 2 5 1 1v5h-5l-3 1-1-2-6-3 1-7z",
    fill: "#707482"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(438,910)",
    d: "m0 0 2 3h2v2l6-1 1 7 5 4h-2v3h-3l-4-4v-5h-3l-1 6-6-1 1-3-2-1 1-3 2-1-1-3-2-2z",
    fill: "#18191E"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(344,407)",
    d: "m0 0 6 1-2 5v2l6-3 2-2-1 4-4 2-4 7h-6l-4-4 6 1-4-5 1-5h2v-2z",
    fill: "#707482"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(519,1136)",
    d: "m0 0 10 1 4 1-14 7-5-2-12-1-1-3 16-2z",
    fill: "#CED1DB"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(572,662)",
    d: "m0 0h5l4 4-1 6-2 2h-8l-2-3v-5z",
    fill: "#D3D6DF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(24,679)",
    d: "m0 0 1 2-1 4-6 1 1 3-4 5-7 1h-8v-5l9-1h3l1-2 5-3 2-3z",
    fill: "#31353E"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,1373)",
    d: "m0 0h9l3 1v5l-2 3-9 2-5-5 1-4z",
    fill: "#17181C"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(84,317)",
    d: "m0 0 2 1v9l-1 3 2 3 1 4v9l-3 5-2-2v-12l-2-3 1-14z",
    fill: "#AFB1BF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,1329)",
    d: "m0 0 25 5 7 3v2l-13-1-20-5-1-3z",
    fill: "#17181C"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,901)",
    d: "m0 0 2 3-4 8-1 5h-6v-3h-2l-1 3h-4l2-6 6-4h3l2-4z",
    fill: "#343841"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(694,790)",
    d: "m0 0 4 2 3 6-1 3h-3v3l-10-2 1-6 2-1 2-4z",
    fill: "#D5D8E2"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(267,309)",
    d: "m0 0h13l10 1-1 3-17 2-5-1-4-1-8 1 4-3z",
    fill: "#6F7381"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(169,994)",
    d: "m0 0h2v2h20l-2 4-12 1h-15v-2l6-2z",
    fill: "#707482"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(383,962)",
    d: "m0 0 9 1 4 3-3 1-1 2-4-1v2h-5l-7 2-5-2-3 1 2-5 3-1v2l9 2v-6z",
    fill: "#17181C"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(824,384)",
    d: "m0 0 5 2v3l4-3 6 1v4l-4-1-1 5h-6v-4l-3 1-2 3h-2v-7z",
    fill: "#707482"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(155,1106)",
    d: "m0 0 8 2 1 5-5 5-5 3-1-5-1-8z",
    fill: "#31353E"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,315)",
    d: "m0 0h2l2 6-1 3 6 1v5h-6v2l-2 1h-6v-3h2v-3l3-1-2-9z",
    fill: "#DADDE6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(373,369)",
    d: "m0 0h2l1 7-4 4h-2l-1 6h-1v-5l-4 2-2 3-9-1 1-3h7l5-4 3-4 1-4z",
    fill: "#31353E"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,330)",
    d: "m0 0 1 2-8 12-6 7-7 16-7 8v-3l4-7 2-7-2 1 2-4 3-2h2l3-5 9-12z",
    fill: "#717583"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,735)",
    d: "m0 0 5 2v10l6-2-1-4 3 1 1 4-12 7-2 2 1-7-1-5-1-7zm-1 20 2 1-1 3h-2z",
    fill: "#373B44"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(175,632)",
    d: "m0 0h5v7h-2l4 1h3v4l-5-1-2 1v-2l-3 1-9-3 3-1v-2h-2v-2l4 1 1 1v-3h2z",
    fill: "#2F333C"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(714,758)",
    d: "m0 0h5l3 2v7l-4 3-5-1-2-4 1-5z",
    fill: "#31353E"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(382,647)",
    d: "m0 0 4 2 3 2v2l4 2 6 5 17 17-2 1-9-7v-2l-4-2-6-5v-2l-4-2-6-7-3-2z",
    fill: "#31353E"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,665)",
    d: "m0 0 4 1 3 6-1 4-8 1-3-4 1-5z",
    fill: "#17181C"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(638,669)",
    d: "m0 0 6 1 2 3-1 6-3 2-5-1-2-2v-6z",
    fill: "#D1D4DE"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(275,285)",
    d: "m0 0 4 1v3 3h-14l-8 4h-2l2-4 7-4z",
    fill: "#707482"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(110,787)",
    d: "m0 0h1v5l-2 2-1 6-3-1v-2l-1 2-8 2 1-7 6-5 4 2 1-3z",
    fill: "#31353E"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(245,425)",
    d: "m0 0h2l4 4v2h-3l1 5-1 2-5 1-4-10-7-1v-1h13z",
    fill: "#B0B2C0"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(747,332)",
    d: "m0 0 5 1 3 1-1 5-7 3-10-1-1-3 3 1 5-1-1-3h3z",
    fill: "#707482"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(154,331)",
    d: "m0 0 3 4-1 5 2 5v4l3 1-1 4-5 3-2 4 1-13v-7l-13-3-1-2 13 1 1-2z",
    fill: "#2D3139"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(716,372)",
    d: "m0 0 7 1 2 2v3l-3 1-2-1v3h-5l-4 1v-8z",
    fill: "#707482"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(203,320)",
    d: "m0 0 3 1-9 6-13 6-8 3-4 1-5-1 4-2 20-8z",
    fill: "#30343D"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(21,893)",
    d: "m0 0 8 1 8 3-2 9 2 1v3h-5v-2h2l-1-3h-4l-1-8-1-1-9-1z",
    fill: "#31353E"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(181,900)",
    d: "m0 0h7l-3 3-13 5-7 5-4-1 1-3 10-5h2l1-3z",
    fill: "#707482"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,1363)",
    d: "m0 0 6 1 3 3v2l6 1v6h-5l-4-4-1-3-6-2v-3z",
    fill: "#17181C"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(454,1012)",
    d: "m0 0 2 2-2 10h2l1 4h-2l-1 2-1-3-3 1-2-5-1-4 3-4h3z",
    fill: "#17181C"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,353)",
    d: "m0 0 5 5 9 11-4 3v-2h-2v-3l-3-1v-2l-4 1-1-1z",
    fill: "#B0B2C0"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(644,534)",
    d: "m0 0 7 1v8l-2 2h-5l-2-2v-8z",
    fill: "#17181C"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(27,436)",
    d: "m0 0 5 2 8 2 1 5h-11l-5-4v-4z",
    fill: "#1C1E23"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(221,1557)",
    d: "m0 0 3 1-1 3-7 2-7 1-4 2h-5v2l-5 1-1-3 14-5 10-3z",
    fill: "#31353E"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,1353)",
    d: "m0 0 4 1 1 6 2 1-1 3-4 1-2-4-5 3-2-5v-3l7 1z",
    fill: "#31353E"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,1119)",
    d: "m0 0h7l1 9-3 1-7-2-1-5 3-1z",
    fill: "#17181C"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(454,1059)",
    d: "m0 0 3 1-1 3-18 4-5 1v-3l2-2z",
    fill: "#707482"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(361,398)",
    d: "m0 0 7 2-3 9v3l2-1-2 8-2-1-2-5-2 3h-2l1-5 5-7 1-3h-3z",
    fill: "#707482"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(202,382)",
    d: "m0 0 2 1-3 3 2 2-3 4v-3l-11 7-4 2v2l-5 3v-4l5-4 12-9z",
    fill: "#25272E"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(291,375)",
    d: "m0 0 5 2-4 3-8 2h-16l-6 1v-2l4-2 20-1 4-1z",
    fill: "#707482"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,616)",
    d: "m0 0 5 2 1 1v5l-4 3-5-2-1-1v-5z",
    fill: "#D0D3DD"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(439,995)",
    d: "m0 0 1 2 2 1-8 6h-10l-2-6 4-2v2l9 2 1-4z",
    fill: "#17181C"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(34,829)",
    d: "m0 0 3 1 4 5-2 5-4 1-1-2h-4l-1-5 3-2v2h2z",
    fill: "#707482"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(729,804)",
    d: "m0 0h3l-1 7-4 3h-6l-2-1 2-4z",
    fill: "#D0D2DC"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641,579)",
    d: "m0 0 5 2 1 5-4 4-5-1-1-1v-6z",
    fill: "#31353E"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(184,383)",
    d: "m0 0 2 1-3 3-9 5-5 4-6 4 1-5h2v-2l4-4 8-4z",
    fill: "#31353E"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,958)",
    d: "m0 0 7 1v6l-12 1-3-2 1-3z",
    fill: "#B0B2C0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,936)",
    d: "m0 0 3 1-1 7h32l-2 2-26 1-4 1-1 3-3-1 1-10z",
    fill: "#31353E"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2,415)",
    d: "m0 0 3 2 4-2 2 5-2 3v-2h-2l1 4-4-1-1 3-3-1v-10z",
    fill: "#B5B7C4"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,1098)",
    d: "m0 0h12l12 1v2l-8 1h-11l-10 2-1-2h2v-2z",
    fill: "#B0B2C0"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,1222)",
    d: "m0 0 1 2 5-2 1 4-6 8-1-3 1-2-5 3-3-1 4-6z",
    fill: "#31353E"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(137,560)",
    d: "m0 0 5 3-1 6-1 1h-6l-2-3 1-5z",
    fill: "#C9CBD6"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(330,1343)",
    d: "m0 0h9l2 3-2 2h-4v2h-2l1 3-4 1-1-1v-7z",
    fill: "#31353E"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,1164)",
    d: "m0 0 2 1v10l-5 8-4 1 1-5 5-12z",
    fill: "#2E323B"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,885)",
    d: "m0 0h6l1 5h-3l-1 4-4-2v2l2 1h-3v-3l-3-1v-5z",
    fill: "#31353E"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(879,549)",
    d: "m0 0 4 3h4v6l-5 1v-2h-3v2l-5-1v-3l3-1z",
    fill: "#B0B2C0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,766)",
    d: "m0 0 3 1h-2v2h-2v3h3l1 2-4 2h-7-3l-5 2 2-4 4-2h3v-2l5-2z",
    fill: "#31353E"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(326,418)",
    d: "m0 0 2 2v10l-3 3-4-6 1-7z",
    fill: "#3F434D"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(188,400)",
    d: "m0 0h1v6h-2l-2 6-3 3v-5l-4 1-1-3 8-7z",
    fill: "#B1B3C1"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(108,1394)",
    d: "m0 0 7 1h4l4 1v3l-4 1-2-1v3l-4 1-5-4 2-3-3-1z",
    fill: "#6F7381"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(356,928)",
    d: "m0 0h2l1 5 2 1-1-3 5 1-2 5-2 2-6-1-1-2h3v-2h-5l1-3-2-1z",
    fill: "#17181C"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(632,853)",
    d: "m0 0h3v2h-2v2l-2 1-2 4-3 7-2-1v-5l-1-5 3-3h6z",
    fill: "#31353E"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(675,577)",
    d: "m0 0h5l2 4-2 6-7-1-1-1v-5h2z",
    fill: "#31353E"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(139,422)",
    d: "m0 0 1 4 2 1-2 4-5 4-1-2-5 2h-6l1-3 13-5z",
    fill: "#31353E"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,1291)",
    d: "m0 0 2 1 1 4-4 3-6 1-6-2 1-4h9z",
    fill: "#31353E"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(7,728)",
    d: "m0 0 2 3v2h-3l1 5-4 4-3-1v-9h4v-2z",
    fill: "#7D818E"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(83,943)",
    d: "m0 0 7 5 1 3-3 1-3-1-3-3v2l-4 1v-2l-6 1 1-4 10-1z",
    fill: "#191A1F"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,1452)",
    d: "m0 0h2v2l5 1 2 3-3 3-4-1v-2h-2l-1 3-6-1 4-5z",
    fill: "#17181C"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(552,956)",
    d: "m0 0 6 1-2 4-11 4h-2v-5z",
    fill: "#31353E"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,753)",
    d: "m0 0 4 1-2 4-8 4-3 4h-2l1-3-2-1 1-3 5-3v3l2-1v-3z",
    fill: "#31353E"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(200,615)",
    d: "m0 0 4 1-2 3-9 1-1 3h-3l1 3-1 3-5 1-1-4 4-4h4v-3h3v-3z",
    fill: "#2F333C"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,497)",
    d: "m0 0 5 1 7 4 3 3v3l5-1v3h-2v3l3 1-5-1v-2l-4-1v-5h-3l-1-3-8-4z",
    fill: "#B0B2C0"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(664,1238)",
    d: "m0 0h2v3l-15 4-4 2h-6l1-2 13-5z",
    fill: "#707482"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(505,955)",
    d: "m0 0 8 2v1l-7 1-2 3-9 1-1 3h-4l-1 3h-3l2-6 10-3h4v-2h3z",
    fill: "#B0B2C0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772,600)",
    d: "m0 0h5l2 2-1 6-6 1-3-5z",
    fill: "#D2D5DF"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(142,364)",
    d: "m0 0 7 1 1 3-8-1-11 9-4 1 2-4 7-6z",
    fill: "#272931"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(850,1191)",
    d: "m0 0h10l4 3-1 3h-3l-1-2h-6l-2 1h-7l2-3z",
    fill: "#707482"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(706,1023)",
    d: "m0 0 4 1 1 2-13 3-12 2-3 1 1-3 7-1 8-3z",
    fill: "#B0B2C0"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(11,933)",
    d: "m0 0h2l4 4-3 2h-3l-1-1-10 2v-5z",
    fill: "#333741"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,635)",
    d: "m0 0h2l1 15-1 5h-2l-2-7-1-9z",
    fill: "#31353E"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1191)",
    d: "m0 0h6l-2 6-4 6h-3l-1 2-2-4 4-2h1v-7z",
    fill: "#17181C"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,1109)",
    d: "m0 0h6l1 1 1 11-5-2-4-6z",
    fill: "#17181C"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,1074)",
    d: "m0 0h10l2 3-1 4h-7l-5-6z",
    fill: "#3C404A"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(684,822)",
    d: "m0 0 2 1v2l10-2 1 3-9 3-8 1-1-3 5-2z",
    fill: "#B0B2C0"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,672)",
    d: "m0 0 5 2 1 4-2 3h-6l-2-4 2-4z",
    fill: "#D0D3DD"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(201,659)",
    d: "m0 0 2 1 1 5 1 2-10 2-4-1 4-5 1-2z",
    fill: "#31353E"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(651,1376)",
    d: "m0 0h2l2 9-1 5-1-2-4 1-1-4v-5h2z",
    fill: "#17181C"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(234,880)",
    d: "m0 0 4 1v9l-1 4-4 1-2-2 3-1-1-7z",
    fill: "#30343D"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(719,1019)",
    d: "m0 0h6v4l-14 3-2-2 3-3z",
    fill: "#BBBDCA"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(523,946)",
    d: "m0 0h8l1 4-13 3v-3z",
    fill: "#D4D7E1"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(210,645)",
    d: "m0 0 4 1 2 1v6h2v2h-4l-1-5-3-1 1 6-2-1v-3l-3-1 1-4z",
    fill: "#707482"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(780,978)",
    d: "m0 0 5 1v2l3-1 1 5-6 1-4-1v-6z",
    fill: "#707482"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(300,953)",
    d: "m0 0h2l4 4v3l-4 2-6-1-2-2 4-5 1 2z",
    fill: "#2D313A"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(313,930)",
    d: "m0 0 5 1-1 3-2 1v3l4-1v3l-7 1-1-3 2-1-5-1 2-5z",
    fill: "#707482"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(368,820)",
    d: "m0 0 3 1v2l-3 1 3 3-12 3-2-1 5-5z",
    fill: "#32363F"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(630,643)",
    d: "m0 0 8 1-5 4-2 10h-1v-10l-9-1 3-2z",
    fill: "#C9CCD7"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,598)",
    d: "m0 0 7 1-4 3 5-1 1 3-9 1-4-1v-4z",
    fill: "#6E7280"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,545)",
    d: "m0 0h5l2 5-3 5-4-1-1-7z",
    fill: "#17181C"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(447,914)",
    d: "m0 0 1 4 2 4 4 3h-2v3h-3l-4-4v-5l-3-1 2-3z",
    fill: "#17181C"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(90,885)",
    d: "m0 0h1v5h4l-1 4-10 3-6-2 3-3 1 2 6-1-2-3 3-1z",
    fill: "#707482"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,877)",
    d: "m0 0 9 3 2 4-4 3v-3h-5l-3-2z",
    fill: "#707482"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(148,442)",
    d: "m0 0 2 1-4 9-1 3-4 2v-12l6-2z",
    fill: "#31353E"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(398,1497)",
    d: "m0 0 4 2-1 4-6 3-4-1 1-4z",
    fill: "#707482"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,1285)",
    d: "m0 0 6 1 2 2-1 5h-6l-2-3z",
    fill: "#31353E"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(550,1260)",
    d: "m0 0h6l-3 3-13 6-2-5z",
    fill: "#31353E"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,1037)",
    d: "m0 0h5l5 3 1 7h-2v-3h-6l-3-2z",
    fill: "#B0B2C0"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(44,901)",
    d: "m0 0h5l-1 4h-2l-4 4-5 1v-4l3-3z",
    fill: "#41454F"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(356,410)",
    d: "m0 0 3 1-3 7-4 4h-2l-1 3-1-5 4-6 3-1z",
    fill: "#D4D7E0"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(883,890)",
    d: "m0 0 4 1v7l-5-1v-2h-6l-1-4 6 1z",
    fill: "#DADDE6"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(367,1349)",
    d: "m0 0 3 2-1 5 2 2-10 1 1-3-3-1 1-2h4l1 2z",
    fill: "#363A44"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(395,1342)",
    d: "m0 0 4 1 6 5-1 4h-2l-1 3-3-4v-4l-3-2z",
    fill: "#31353E"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(114,860)",
    d: "m0 0 3 1v2l-4 1v2h-7l-1 3h-3v-2l-2-1 8-4z",
    fill: "#707482"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(793,597)",
    d: "m0 0 6 2 1 4-1 1h-12v-2h4v-2l-2-1 2-1 2 1z",
    fill: "#31353E"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(244,349)",
    d: "m0 0v3l-4 3 1 2-12 8-1-3 8-7z",
    fill: "#BCBECA"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,1158)",
    d: "m0 0 3 2-1 5-5 6-2-1 2-9z",
    fill: "#B0B2C0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,1009)",
    d: "m0 0h2l-1 6-2 5h-7l3-6 2-1 1-3z",
    fill: "#17181C"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(607,580)",
    d: "m0 0h6l3 3v3l-13-1 1-2h2z",
    fill: "#1A1C20"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(346,404)",
    d: "m0 0 13 1-1 3h-2l-2 5-5 2 1-4 3-1 1-2-9-2z",
    fill: "#1D1F24"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(142,848)",
    d: "m0 0 5 2-2 4-9 1v-4z",
    fill: "#707482"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(690,795)",
    d: "m0 0h1v5h5l4-4 1 4-4 1v3l-10-2 1-6z",
    fill: "#B0B2C0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(376,634)",
    d: "m0 0 1 2h2v3h4v3h2v2l-4-1 1 4-7-5z",
    fill: "#31353E"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(265,323)",
    d: "m0 0 3 1-9 6-8 4-2-1 10-8z",
    fill: "#727684"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,1138)",
    d: "m0 0h6l-1 5-14-1-1-3z",
    fill: "#B0B2C0"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,518)",
    d: "m0 0 6 1-1 6-4 1-3-2v-5z",
    fill: "#C3C5D1"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(79,354)",
    d: "m0 0 3 4 1 2v8l-3 1-2-6z",
    fill: "#707482"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(850,1571)",
    d: "m0 0h3l5 5 1 3-2 4-2-1v-2h-2v-5h-2z",
    fill: "#31353E"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(667,1191)",
    d: "m0 0 7 1 1 4-6 2h-5l2-6z",
    fill: "#17181C"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(37,1017)",
    d: "m0 0 2 3-1 5h-5l-1-4-2-1 1-2z",
    fill: "#31353E"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(311,946)",
    d: "m0 0 3 1 2 4 3 1-1 3h-2l-1 2-4-2-1-8z",
    fill: "#31353E"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(420,924)",
    d: "m0 0 4 1 1 1v7 3h-5l-1 2h-2l-1-5 5 1 1-8-3-1z",
    fill: "#17181C"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(331,418)",
    d: "m0 0 6 1 5 5-2 2-6-1-3-5z",
    fill: "#D2D5DF"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(622,382)",
    d: "m0 0 5 1 2 2-1 5-4-1-3-1v-5z",
    fill: "#DADDE6"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(253,359)",
    d: "m0 0 2 1-8 9-8 6-6 2 1-3 8-5 5-3z",
    fill: "#737785"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(338,870)",
    d: "m0 0 6 1v2l-8 2-1 3-1-2-5-2 4-2z",
    fill: "#31353E"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,650)",
    d: "m0 0 4 2v5l-4 2-3-2v-5z",
    fill: "#D0D3DD"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(562,567)",
    d: "m0 0 5 1 2 3-1 3-8-2-3-2z",
    fill: "#C2C4D0"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(771,563)",
    d: "m0 0 4 1v5l-1 1-7-1-1-4z",
    fill: "#B8BAC7"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(234,1552)",
    d: "m0 0h5v3l-3 2-11 1v-2z",
    fill: "#31353E"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(538,1127)",
    d: "m0 0h2v3l6 1v3l4 1-2 2-5 1 1-3h-2v-2h-5l2-1z",
    fill: "#31353E"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(235,927)",
    d: "m0 0 6 1 1 1v6h-7v-4l-1-2z",
    fill: "#32363F"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(214,621)",
    d: "m0 0 7 1v3l3 1-4 3-5-1v-4l-2-2z",
    fill: "#707482"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,592)",
    d: "m0 0 11 1-4 5h-6l-2-5z",
    fill: "#17181C"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,563)",
    d: "m0 0 6 1v4l-7 1h-4v-2l4-1z",
    fill: "#BEC0CC"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(722,512)",
    d: "m0 0 5 1v5l-1 1h-5l-2-2 1-4z",
    fill: "#C5C7D3"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,387)",
    d: "m0 0 2 3 2 4v3h2l1 6h-3l-4-7z",
    fill: "#22242A"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(383,383)",
    d: "m0 0 1 2-8 12-4 2 1-5 4-5h3l2-5z",
    fill: "#2D3139"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(354,977)",
    d: "m0 0h8l-1 2-11 3h-5l1-3z",
    fill: "#707482"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(80,795)",
    d: "m0 0h2v2l-4 3-5 3-2 3-5 2-2 2h-2l1-4 8-4z",
    fill: "#31353E"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,735)",
    d: "m0 0 5 2v12l-4-4-2-9z",
    fill: "#707482"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(393,365)",
    d: "m0 0 2 3v6l-4 2-2 4h-3l-1 3-1-2 3-5h2v-2h2z",
    fill: "#31353E"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,1390)",
    d: "m0 0 5 3 1 3-2 4h-2v-2l-4-2z",
    fill: "#17181C"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(140,1115)",
    d: "m0 0 1 2-1 2-10 3-3-1 3-4z",
    fill: "#31353E"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(428,924)",
    d: "m0 0 7 2-2 1v2h2l1 3h-3l1-2h-8l1-5z",
    fill: "#17181C"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(286,368)",
    d: "m0 0 4 2 4 3 3-1 2-4 1 8h-3l-7-1-4-5z",
    fill: "#707381"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(282,287)",
    d: "m0 0h4v2l5 1-1 2h-7l-8-2 4-2z",
    fill: "#B7B9C6"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(31,674)",
    d: "m0 0h13l-1 2-6 1-1 2-5-1-4-2z",
    fill: "#31353E"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,557)",
    d: "m0 0 5 1v5l-1 1h-5l-1-6z",
    fill: "#272A31"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(21,427)",
    d: "m0 0 5 5 2 4-3 1-1 2-5-8v-2h2z",
    fill: "#30343D"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(666,1205)",
    d: "m0 0 2 1-1 3-6 3h-6l2-3h3v-2z",
    fill: "#1F2026"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(834,1146)",
    d: "m0 0h3v3l-6 3-5-1 1-4z",
    fill: "#B0B2C0"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(198,667)",
    d: "m0 0h7l-1 3-5 2-8-1v-2z",
    fill: "#707482"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(376,339)",
    d: "m0 0 5 2 4 9v2l2 1-4-1-2-1v-6l-5-1z",
    fill: "#31353E"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(371,803)",
    d: "m0 0 4 1-1 4-5 5h-2v-7l3-1z",
    fill: "#707482"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(166,527)",
    d: "m0 0 5 1 1 4-1 2h-5l-1-5z",
    fill: "#737785"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(353,433)",
    d: "m0 0 5 2v5l-5 1-2-4z",
    fill: "#C3C5D1"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(259,418)",
    d: "m0 0 2 1-6 8-4 9h-2l-1-5h3l2-5 3-5z",
    fill: "#707482"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(87,376)",
    d: "m0 0 4 2 10 8v2l-5-1v-2l-4-2-5-5z",
    fill: "#B0B2C0"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(465,329)",
    d: "m0 0 5 1v3l-5 2-4-1v-4z",
    fill: "#B0B2C0"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,1343)",
    d: "m0 0 6 1 8 5v2l-9-3-5-3z",
    fill: "#31353E"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,953)",
    d: "m0 0 8 2v2l-17 3-1-2 10-2z",
    fill: "#707482"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(207,589)",
    d: "m0 0h5l1 4-3 3-4-1v-5z",
    fill: "#BDBFCC"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(710,554)",
    d: "m0 0 5 2-1 5h-5l-1-1v-5z",
    fill: "#23252C"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(52,434)",
    d: "m0 0 2 1-2 4 4 1-9 4-1-7z",
    fill: "#31353E"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,394)",
    d: "m0 0h2l-2 4-4 4-2 5-6 5 2-4 3-4 3-7z",
    fill: "#5D616D"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(154,348)",
    d: "m0 0 3 2 4-1-1 5-5 3-2 4z",
    fill: "#31353E"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(264,300)",
    d: "m0 0h9v2l-10 2h-7l1-2z",
    fill: "#707482"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(204,1371)",
    d: "m0 0 2 4 1 1v6h-3v-2l-5-2 2-1 3-1-3-1v-3z",
    fill: "#6E7280"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(218,936)",
    d: "m0 0 6 1 1 2h1v5l-4 1v-5l-5-2z",
    fill: "#31353E"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(606,735)",
    d: "m0 0 3 1 2 9-4 3-1-1z",
    fill: "#17181C"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(133,479)",
    d: "m0 0 1 4-1 3h4l-3 10-2-4-1-4 1-8z",
    fill: "#31353E"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,458)",
    d: "m0 0 3 2-1 4-1 1h-5v-5z",
    fill: "#DADDE6"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(361,398)",
    d: "m0 0 7 2-2 5-3 5h-2l1-4 2-5h-3z",
    fill: "#1F2127"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,1286)",
    d: "m0 0h4l2 7-3 1-4-2z",
    fill: "#31353E"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(11,885)",
    d: "m0 0h11l-2 4-8-2v2l-5-1 1-2z",
    fill: "#31353E"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(263,882)",
    d: "m0 0h6l2 5-5 1-1-2-4-2z",
    fill: "#31353E"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,658)",
    d: "m0 0 3 1v3h-19v-2l15-1z",
    fill: "#B3B5C3"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,554)",
    d: "m0 0 5 1v5l-5 1-1-1v-5z",
    fill: "#212329"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(138,100)",
    d: "m0 0 4 1 1 5h-9l3-5z",
    fill: "#31353E"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(145,1126)",
    d: "m0 0h5v3 2l-5 2h-5v-2h4l-1-2h2z",
    fill: "#31353E"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(596,703)",
    d: "m0 0 3 1-2 1v3l-6 2-1-4v-2h5z",
    fill: "#707482"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(691,680)",
    d: "m0 0h5v5l-2 2-4-1v-3l-2-1z",
    fill: "#17181C"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,655)",
    d: "m0 0 5 2-1 4h-10l1-2 4-1z",
    fill: "#31353E"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(700,599)",
    d: "m0 0h5l-4 2-2 3-4-1v-2l-2 1h-10v-1l16-1z",
    fill: "#31353E"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(838,538)",
    d: "m0 0 7 1-1 3-2 1h-6v-4z",
    fill: "#B0B2C0"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(33,439)",
    d: "m0 0 7 1 1 5h-11l4-2z",
    fill: "#2C3038"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(296,378)",
    d: "m0 0 4 1 1 6h-9l-5 1v-2l10-3 1-1z",
    fill: "#787C8A"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,376)",
    d: "m0 0v3l-5 5-3-1 1-6z",
    fill: "#DADDE6"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,1270)",
    d: "m0 0h6l-5 4-5 2-3-1 4-4z",
    fill: "#25282F"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(107,695)",
    d: "m0 0 2 2h-3l1 4-2 1v-2h-5l-2-1 1-3z",
    fill: "#17181C"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(202,382)",
    d: "m0 0 2 1-3 3 2 2-3 4v-3l-5 2-1-3z",
    fill: "#2A2D35"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(195,1438)",
    d: "m0 0 2 2 2 5-2 4-4-3 1-7z",
    fill: "#17181C"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,1401)",
    d: "m0 0h7l-2 5-1 3-4-4-1-3z",
    fill: "#17181C"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,1334)",
    d: "m0 0 7 1-1 5-7-2z",
    fill: "#31353E"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(538,1212)",
    d: "m0 0h9l-2 2-5 2-2-1-13-1v-1z",
    fill: "#31353E"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(9,895)",
    d: "m0 0 6 1-4 2-11 3v-5h3v2z",
    fill: "#31353E"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(724,595)",
    d: "m0 0h6v1l-9 1-2 4-2-1v-2h-8v-1z",
    fill: "#31353E"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,588)",
    d: "m0 0h5l1 4-2 2-4-1-1-4z",
    fill: "#CCCFD9"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(826,580)",
    d: "m0 0 3 1v5l-5 1-1-5z",
    fill: "#D2D5DF"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(335,436)",
    d: "m0 0 3 3 3 5 2 4-5-1-3-7z",
    fill: "#31353E"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(170,399)",
    d: "m0 0 2 4-7 6h-2l1-5z",
    fill: "#B0B2C0"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(85,385)",
    d: "m0 0 6 2 5 5-7-1-4-4z",
    fill: "#1A1C21"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(161,315)",
    d: "m0 0h1l2 11v5l-2-4-2-1 1-7-3 1 2-4z",
    fill: "#31353E"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,880)",
    d: "m0 0 9 1 3 3-3 1-9-2z",
    fill: "#17181C"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(312,874)",
    d: "m0 0 5 1-4 4-7-2-1-2z",
    fill: "#31353E"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,584)",
    d: "m0 0 4 1 1 4-4 2-3-3z",
    fill: "#CACDD8"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(335,573)",
    d: "m0 0 3 4 1 3-4 2v-2h-3l1-5z",
    fill: "#31353E"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(367,411)",
    d: "m0 0 4 2 1 5-6 1v-6z",
    fill: "#D4D7E1"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(40,392)",
    d: "m0 0 4 2 5 8h-3v-2l-4-2z",
    fill: "#B0B2C0"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,303)",
    d: "m0 0 8 1v2l-3 1-2 3h-3z",
    fill: "#707482"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(619,230)",
    d: "m0 0 2 2 3 2 9 4-3 1-10-4-3-3z",
    fill: "#ACAEBC"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(405,1359)",
    d: "m0 0 4 2-1 5h2l1-2v3l-5 1-1-5-1-3z",
    fill: "#31353E"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(354,1351)",
    d: "m0 0h3l2 8h-4l-4-1v-2h5v-2h-3z",
    fill: "#31353E"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,1236)",
    d: "m0 0 3 1h-2v2l2-1h6l-2 2-7 2-1-3-6 1 2-2z",
    fill: "#31353E"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412 1e3)",
    d: "m0 0h3v2h3l1 4-1 2-4-1-2-6z",
    fill: "#17181C"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(185,958)",
    d: "m0 0 5 2-1 2h-2l-1 4-3-1-1-5z",
    fill: "#31353E"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(187,622)",
    d: "m0 0h2l1 4-1 3-5 1-1-4z",
    fill: "#2E323A"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(113,478)",
    d: "m0 0 4 1v5l-4 1-2-4z",
    fill: "#C5C7D3"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(843,1464)",
    d: "m0 0 4 1v3l-7 2-1-3 2-2z",
    fill: "#6D717F"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(507,852)",
    d: "m0 0 5 1 1 2-8 2-3-2z",
    fill: "#333740"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(50,811)",
    d: "m0 0h12l-3 1v2h-7l-4 3-1-4z",
    fill: "#31353E"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(691,803)",
    d: "m0 0h2l2 5-1 4-5-1z",
    fill: "#B0B2C0"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(525,350)",
    d: "m0 0 5 1v4l-5 1-1-5z",
    fill: "#DADDE6"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(529,1137)",
    d: "m0 0 4 1-8 4-5 1 3-4v-1z",
    fill: "#B0B2C0"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641,581)",
    d: "m0 0 4 2-1 4h-4l-1-4z",
    fill: "#17181C"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(675,579)",
    d: "m0 0 5 1-1 5h-4l-1-4z",
    fill: "#17181C"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(589,1204)",
    d: "m0 0h2l-2 6h-10l2-2h6v-3z",
    fill: "#333740"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,1110)",
    d: "m0 0 4 1h-2v2l-8 3-3-1 3-3z",
    fill: "#B0B2C0"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(483,1074)",
    d: "m0 0 2 1-3 3-9 1v-2h2v-2h7z",
    fill: "#31353E"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,969)",
    d: "m0 0h10v2l-4 1-5 1h-4l1-3z",
    fill: "#B0B2C0"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,852)",
    d: "m0 0h5l-1 3-9 3-1-2z",
    fill: "#31353E"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,645)",
    d: "m0 0h5l-1 5h-5l-1-2z",
    fill: "#282B32"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(805,525)",
    d: "m0 0h4v6l-6 1-1-2h3z",
    fill: "#DADDE6"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(265,348)",
    d: "m0 0v3l-2 5-8 3 2-4 3-2h2z",
    fill: "#6D717F"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(176,332)",
    d: "m0 0 4 1-5 4-8-1 4-2z",
    fill: "#31353E"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(466,192)",
    d: "m0 0h5l2 4-3 1-5-1z",
    fill: "#333740"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(755,1495)",
    d: "m0 0h8l3 1v2h-11z",
    fill: "#31353E"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,743)",
    d: "m0 0 2 3-7 3-3-1 1-3 5-1z",
    fill: "#31353E"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(679,730)",
    d: "m0 0m-3 0 2 4-2 1v-2h-2l-1 4-2 1v-5z",
    fill: "#707482"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(20,694)",
    d: "m0 0h2l1 4h2v-4h3l-1 5-5 1-2-1z",
    fill: "#31353E"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(79,681)",
    d: "m0 0 3 1-1 2 4 1-2 2-3-1-1 2-2-1z",
    fill: "#31353E"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(517,336)",
    d: "m0 0 5 2 2 4-7-1-1-4z",
    fill: "#707482"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,1504)",
    d: "m0 0 7 1-3 6h-2l-1-4-2-2z",
    fill: "#353943"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,1417)",
    d: "m0 0 7 1-2 5-4-1z",
    fill: "#707482"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(335,1353)",
    d: "m0 0 5 3 3 4-5 1-3-3z",
    fill: "#353943"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(690,1137)",
    d: "m0 0 5 1 1 5-3 1-2-2z",
    fill: "#31353E"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(487,1072)",
    d: "m0 0h11l-8 4-4-1z",
    fill: "#31353E"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(85,802)",
    d: "m0 0 7 1-1 4-4 1v-3h-2z",
    fill: "#353943"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(38,690)",
    d: "m0 0 2 3 1 6-4-2-1-5z",
    fill: "#30333C"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(222,679)",
    d: "m0 0 1 2-2 9-4 3 2-7z",
    fill: "#31353E"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(167,667)",
    d: "m0 0 6 1v5l-6 1 2-4-3-1z",
    fill: "#707482"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(679,642)",
    d: "m0 0 6 1-3 7h-2z",
    fill: "#353943"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(372,372)",
    d: "m0 0h4l-1 5-5 1z",
    fill: "#707482"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(26,370)",
    d: "m0 0 9 4 1 4-5-2-5-3z",
    fill: "#B6B8C5"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(147,1465)",
    d: "m0 0 2 4-1 3h-3l-1 2 1-7z",
    fill: "#17181C"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(270,1414)",
    d: "m0 0 10 1-1 3-8-1z",
    fill: "#31353E"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(233,1027)",
    d: "m0 0 3 1 1 6-4-1-1-5z",
    fill: "#707482"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(141,977)",
    d: "m0 0h5v3l-1 1h-6v-3z",
    fill: "#31353E"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(660,623)",
    d: "m0 0 8 1v3h-8z",
    fill: "#707482"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595,558)",
    d: "m0 0 4 1-1 4h-4v-4z",
    fill: "#727684"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(41,284)",
    d: "m0 0 3 3 2 5-1 4-2-3-2-5z",
    fill: "#31353E"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(131,164)",
    d: "m0 0 2 2-1 6-3 5-1-3z",
    fill: "#31353E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.8d28e58db0423ad333808bcd9a2f4962.svg";
export { ForwardRef as ReactComponent };